import type { Translation } from '../i18n-types';
import baseLanguageValues from '../en-US';

export const translationValues: Partial<Translation> = {
    SHEETS: 'Tabele',
    DASHBOARDS: 'Kontrolne table',
    DATABASE_TABLE: 'Tabela u bazi podataka',
    VARIABLES: 'Varijable',
    FILES: 'Fajlovi',
    APPS: 'Aplikacije',
    LABEL: 'Oznaka',
    EDIT_TYPE: 'Vrsta uređivanja',
    EDITING_ROW: 'Uređivanje reda {label}',
    CREATE_NEW_ROW: 'Kreiraj novi red',
    ADD: 'Dodaj',
    MULTIPLY: 'Pomnoži',
    SET: 'Postavi',
    PERCENT_CHANGE: 'Promena procenta',
    NAME: 'Ime',
    NAME_AND_STYLE: 'Naziv i stil',
    PATH: 'Putanja',
    SHARE_WITH: 'Deli sa',
    SUBMIT: 'Pošalji',
    EDIT: 'Uredi',
    ANY: 'Bilo koji',
    VIEW: 'Pregledaj',
    EDITING: 'Uređivanje',
    DUPLICATE: 'Dupliciraj',
    DUPLICATE_SHEET_LOADING: 'Dupliciranje proračunske tablice...',
    DUPLICATE_SHEET_SUCCESS: 'Proračunska tablica je uspešno duplicirana',
    DUPLICATE_SHEET_ERROR: 'Greška prilikom dupliciranja sheeta',
    DUPLICATE_FOLDER_LOADING: 'Dupliciranje foldera...',
    DUPLICATE_FOLDER_SUCCESS: 'Folder je uspešno dupliciran',
    DUPLICATE_FOLDER_ERROR: 'Greška prilikom dupliciranja foldera',
    DELETE_TILE: 'Obriši element',
    MATCH_CASE: 'Razlikuj velika/mala slova',
    SEARCH: 'Pretraži',
    SEARCH_VALUES: 'Pretraži vrednosti',
    IMPORT: 'Uvoz',
    MODEL_HEALTH: 'Zdravlje modela',
    CHECKLIST: 'Kontrolna lista',
    DYNAMIC_ANALYSIS: 'Dinamička analiza',
    STATIC_ANALYSIS: 'Statička analiza',
    CALCULATION_LOGS: 'Zapisi izračunavanja',
    ERROR_MESSAGE: 'Poruka greške',
    CALCULATION_TIME_MS: 'Vreme izračunavanja (ms)',
    ERRORS: 'Greške',
    WARNINGS: 'Upozorenja',
    AMPLIFICATION_FACTOR: 'Faktor pojačanja',
    CELL_COUNT_ESTIMATE: 'Broj ćelija (procena)',
    NO_CALCULATION_ERRORS: 'Nema grešaka u izračunavanju',
    CALCULATION_ERRORS: 'Pronađene greške u izračunavanju',
    NO_MODELLING_ERRORS: 'Nema grešaka u modelovanju',
    MODELLING_ERRORS: 'Pronađene greške u modelovanju',
    MODEL_FULLY_LOADED: 'Model je potpuno učitan',
    MODEL_NOT_LOADED: 'Model nije učitan',
    SHARING: 'Deljenje',
    ASSIGNMENT: 'Zadatak',
    ASSIGNMENTS: 'Zadaci',
    LOAD_MORE: 'Učitaj još',
    SHARE: 'Podeli',
    OPEN: 'Otvori',
    NONE: 'Ništa',
    TABLE: 'Tabela',
    VALUE: 'Vrednost',
    DATE: 'Datum',
    NONE_SELECTED: 'Ništa izabrano',
    VALUE_FOR_MONTH: 'Vrednost za mesec',
    DESCRIPTION: 'Opis',
    NOTES: 'Beleške',
    CUSTOM_FIELD: 'Prilagođeno polje',
    TABLE_DESCRIPTION: 'Opis tabele',
    EDIT_COLUMN: 'Uredi kolonu',
    COLUMN_TYPE: 'Tip kolone',
    MONTH: 'Mesec',
    VARIABLE_AND_DIMENSIONS: 'Varijabla & dimenzije',
    SHOW_UNMAPPED: 'Odaberi samo nespojene stavke',
    MANUAL_MAPPING: 'Ručno mapiranje',
    CLEAR: 'Obriši',
    AUTODETECT: 'Automatsko otkrivanje',
    FILTER: 'Filter',
    SELECT_ALL_BRACKETS: '(Odaberi sve)',
    BLANK_CELLS_BRACKETS: '(Prazne ćelije)',
    SELECT_DIMENSIONS: 'Odaberi dimenzije',
    CONFIRM: 'Potvrdi',
    REMOVE_ALL_MAPPINGS_CONFIRM: 'Da li ste sigurni da želite ukloniti sva mapiranja?',
    REMOVE_MANUALLY_ADDED_MAPPING_TAGS: 'Ova akcija će ukloniti sve ručno dodate oznake mapiranja.',
    ERROR_IMPORTING_FILE: 'Greška prilikom uvoza fajla',
    CHOOSE_JOB_TO_REPLACE: 'Izaberite posao za zamenu',
    PREVIOUS_IMPORTS: 'Prethodni uvozi',
    WELCOME_TO_IMPORT: 'Dobrodošli na uvoz.',
    IMPORT_SPREADSHEETS: 'Uvezi svoje tabele iz Excela direktno u Farseer i upravljaj njima.',
    DRAG_FILE_HERE: 'Povucite vaš fajl ovde',
    OR: 'ILI',
    BROWSE: 'Pregledaj',
    IMPORT_MISSING_MEMBERS: 'Uvezi nedostajuće članove',
    IMPORT_VALUES: 'Uvezi vrednosti',
    NO_COLUMN_SET_AS_TABLE: 'Nema kolone postavljene kao vrednost',
    NO_COLUMN_SET_AS_VALUE: 'Nema kolone postavljene kao vrednost',
    MISSING_MEMBERS: 'Nedostaju članovi dimenzije',
    SELECT_ALL: 'Odaberi sve',
    DESCRIPTION_COLUMN: 'Kolona sa opisom',
    CONNECTED_DIMENSIONS_COLUMN: 'Povezane dimenzije kolona',
    CANCEL: 'Otkaži',
    CONTINUE: 'Nastavi',
    CREATE_DIMENSIONS: 'Kreiraj dimenzije',
    SELECT_CONNECTION: 'Odaberi konekciju',
    CLOSE: 'Zatvori',
    SAVE: 'Sačuvaj',
    DELETE: 'Obriši',
    REMOVE: 'Ukloni',
    DELETING_ASSIGNMENT: 'Brisanje zadatka {multiple} ...',
    DELETED_ASSIGNMENT: 'Zadatak {multiple} je obrisan!',
    FAILED_DELETE_ASSIGNMENT: 'Brisanje zadatka {multiple} nije uspelo',
    DELETE_ASSIGNMENT: 'Obriši zadatak {multiple}',
    DELETE_ASSIGNMENT_CONFIRMATION: 'Da li želite da obrišete izabrani zadatak {multiple}?',
    COLUMNS: 'Kolone',
    FORMATTING: 'Formatiranje',
    PRESERVE_FORMATTING: 'Zadrži formatiranje',
    CUSTOM_FORMATTING: 'Prilagođeno formatiranje',
    GROUP_OUTLIERS: 'Grupiši odstupanja',
    VERSIONS: 'Verzije',
    NONE_VERSION: 'Nijedna',
    APPLY_TO_ALL_YEARS: 'Primeni na sve godine',
    SHEET_OPTIONS: 'Opcije proračunske tablice',
    DASHBOARD_OPTIONS: 'Opcije kontrolne table',
    LOCK_GRID: 'Zaključaj mrežu',
    RESPONSIVE_LAYOUT: 'Prilagodljivi raspored',
    AUTO_REFRESH_DASHBOARD: 'Automatsko osvežavanje kontrolne table',
    REFRESH_DASHBOARD: 'Osveži kontrolnu tablu',
    ONLY_WITH_DATA: 'Samo sa podacima',
    OWD_INCLUDE_MEASURES: 'Uključi mere',
    STACKED: 'Složeno',
    TIMELINE: 'Vremenska linija',
    RESET_COLUMN_ORDER: 'Resetuj redosled kolona',
    STANDARD_COLUMNS_NAME: 'Ime',
    STANDARD_COLUMNS_DESCRIPTION: 'Opis',
    STANDARD_COLUMNS_NAME_PLUS_DESCRIPTION: 'Ime + opis',
    DOWNLOADING_FILE: 'Preuzimanje fajla',
    FILE_DOWNLOADED: 'Fajl je preuzet',
    FAIL_FILE_DOWNLOAD: 'Neuspešno izvođenje iz odabrane konfiguracije',
    ADD_TO_DASHBOARD: 'Dodaj na tablu',
    SUBMIT_ENTRIES_CONFIRMATION: 'Da li ste sigurni da želite da pošaljete unos?',
    FURTHER_CHANGES_AND_LINK_LOCKED_AFTER_SUBMIT: 'Nakon slanja nećete moći vršiti dalje promene i veza će biti zaključana.',
    LINK_NOT_FOUND: 'Veza nije pronađena',
    LINK_EXPIRED: 'Ovaj link je istekao',
    DEPLOYMENT: 'Implementacija',
    UNKNOWN: 'Nepoznato',
    FILE_SIZE_10GB: 'Veličina fajla > 10GB',
    FILE_SIZE_64MB: 'Veličina fajla > 64MB',
    FILE_SIZE_1MB: 'Veličina fajla > 1MB',
    FILE_SIZE_TOO_LARGE: 'Veličina fajla je prevelika',
    UPLOADED: 'Preneseno',
    ERROR_UPLOADING_FILE: 'Greška prilikom prenosa fajla',
    FOLDER_NAME: 'Ime fascikle',
    NEW_DIMENSION_TABLE: 'Nova dimenziona tabela',
    NEW_VARIABLE: 'Nova varijabla',
    NEW_DASHBOARD: 'Nova tabla',
    NEW_SHEET: 'Nova proračunska tabela',
    UPLOAD_FILE: 'Prenesite fajl',
    NEW_FOLDER: 'Nova fascikla',
    NEW_REMOTE_JOB: 'Nova aplikacija',
    DOWNLOAD: 'Preuzmi',
    DELETE_MENU_ITEM_CONFIRM: 'Da li ste sigurni da želite da obrišete {menuItem}?',
    USER_REMOVED: 'Korisnik je uklonjen!',
    FAILED_USER_REMOVE: 'Brisanje korisnika nije uspelo',
    USER_DELETING: 'Brisanje korisnika {fullName}',
    USER_DELETING_CONFIRM: 'Da li ste sigurni da želite da obrišete korisnika {fullName}?',
    CONFIRM_DELETE_OPERATION: 'Potvrdi brisanje operacije',
    DELETE_YEAR_CONFIRMATION: 'Da li ste sigurni da želite da obrišete godinu {year}?',
    DELETE_VARIATION_CONFIRMATION: 'Da li ste sigurni da želite da obrišete verziju {name}?',
    YEARS: 'Godine',
    YEAR: 'Godina',
    ADD_YEAR: 'Dodaj {year}',
    OPTIONS: 'Opcije',
    NO_VERSION_SELECTED: 'Nije izabrana verzija',
    INTERVAL_START_GREATER: 'Početak intervala veći od kraja nekih intervala',
    INTERVAL_END_GREATER: 'Kraj intervala manji od nekih početaka intervala',
    INTERVAL_START_GREATED_END: 'Početak intervala veći od kraja',
    NO_NAME_INPUT: 'Zadatak mora imati ime',
    EDIT_ASSIGNMENTS: 'Uredi zadatke',
    ASSIGNMENT_NAME: 'Ime zadatka',
    VERSION: 'Verzija',
    ADD_VERSION: 'Dodaj verziju',
    ADD_NEW_VERSION: 'Dodaj novu verziju',
    NEW_VERSION_NAME: 'Ime nove verzije',
    ERROR_ADDING_VERSION: 'Greška prilikom dodavanja verzije.',
    NAME_AND_COLOR: 'Ime i boja',
    ADDED_BY: 'Dodato od strane',
    CREATE_SERVICE_USER: 'Kreiraj korisnika usluge',
    CREATE_USER: 'Kreiraj korisnika',
    USER_TYPE: 'Tip korisnika',
    STANDARD: 'Standard',
    SERVICE: 'Služba',
    CREATED_SERVICE_USER: 'Kreiran korisnik usluge',
    FAILED_CREATE_SERVICE_USER: 'Kreiranje korisnika usluge i API ključa nije uspjelo',
    SERVICE_USER_NAME_REQUIRED: 'Naziv korisnika usluge je obavezan',
    CREATED_USER: 'Korisnik kreiran',
    FAILED_CREATE_USER: 'Kreiranje korisnika nije uspjelo',
    LAST_NAME_REQUIRED: 'Prezime je obavezno',
    FIRST_NAME_REQUIRED: 'Ime je obavezno',
    EMAIL_REQUIRED: 'Email je obavezan',
    PASSWORD_REQUIRED: 'Lozinka je obavezna',
    PASSWORD_INCORRECT: 'Pogrešna lozinka',
    FIRST_NAME: 'Ime',
    LAST_NAME: 'Prezime',
    EMAIL: 'Email',
    PASSWORD: 'Lozinka',
    CONFIRM_PASSWORD: 'Potvrdi lozinku',
    API_KEY: 'API ključ',
    CREATED_SERVICE_USER_API_KEY: 'API ključ za korisnika usluge {serviceUserName} je kreiran',
    API_KEY_COPIED_TO_CLIPBOARD: 'API ključ je kopiran u međuspremnik',
    CONNECT: 'Poveži se',
    DISCONNECT: 'Odspoji se',
    MIXED_VERSIONS: 'Mešovite verzije',
    MIXED: 'Mešovito',
    USE_RESTRICTIONS: 'Ograniči unos na verzije i intervale',
    ALLOW_ENTRY_ON_PROPERTY_COLUMNS: 'Dozvoli unos u kolone svojstava',
    PROPERTY_COLUMNS: 'Kolone svojstava',
    USE_TIME_LIMIT: 'Koristi vremensko ograničenje',
    SELECT_VERSION: 'Odaberite verziju',
    EXPIRES_AFTER: 'Istoči nakon',
    CHANGE: 'Promeni',
    SMART_FILTER_CHANGE: 'Promena',
    CHANGES_SUBMITTED: 'Promene su podnete. Čekanje na pregled.',
    SUBMITTED: 'Podneto',
    ASSIGNMENTS_AVAILABLE: 'dostupni zadaci',
    SUBMITTING_ASSIGNMENT: 'Podnošenje zadatka',
    SUBMITED_ASSIGNMENT: 'Zadatak je podnet',
    FAIL_SUBMIT_ASSIGNMENT: 'Neuspelo podnošenje zadatka',
    ASSIGNMENT_LABEL_CREATED: 'Oznaka kreirana i dodata zadatku',
    SUBMIT_CHANGES: 'Podneti promene?',
    SUBMIT_CHANGES_CONFIRMATION: 'Da li ste sigurni da želite podneti promene? Nećete moći da vršite dalje izmene, proces će biti označen kao spreman za pregled i vlasnik proračunske tablice će biti obavešten.',
    CANT_UNDONE_ACTION: 'Ova radnja se ne može poništiti',
    APP_LANGUAGE: 'Jezik aplikacije',
    TARGET_VERSION_SAME_AS_SOURCE_VERSION_ERROR: 'Ciljna verzija ne može biti ista kao izvorna verzija',
    TARGET_VERSION: 'Ciljna verzija',
    SELECT_TARGET_VERSION: 'Molim izaberite ciljnu verziju',
    SOURCE_VERSION: 'Izvorna verzija',
    SELECT_SOURCE_VERSION: 'Molim izaberite izvornu verziju',
    ROW_TAGS: 'Oznake reda',
    DELETE_THIS_ROW: 'Izbriši ovaj red',
    SELECT_PARENT_TAG_FOR_MULTIPLE_ROWS_GENERATING: 'Izaberite nadređenu oznaku za generisanje više redova',
    GLOBAL_SEARCH_PLACEHOLDER: 'Pretražite proračunske tabele, nadzorne table, baze podataka i varijable',
    NO_RESULTS_FOUND: 'Nema rezultata',
    NEW_TILE: 'Novi element',
    SLICER_STATE_SAVED: 'Slicer stanje sačuvano za sve!',
    INVALID_LINK: 'Neispravan link',
    LINK_NOT_EXIST: 'Link ne postoji',
    ACCESS_NOT_GRANTED: 'Pritup domaćinu nije dozvoljen',
    CONTACT_ADMIN: 'Molimo kontaktirajte vašeg administratora za više informacija',
    LOGOUT: 'Odjava',
    REGENERATING_LINKS: 'Regeneracija linkova...',
    REGENERATED: 'Regenerisano!',
    FAILED_REGENERATING_LINKS: 'Neuspešno regenerisanje linkova za izabrane javne zadatke',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS: 'Regenerirati linkove za odabrane zadatke?',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS_CONFIRMATION: 'Da li ste sigurni da želite regenerisati linkove za izabrane zadatke? Stari linkovi će postati nevažeći. Ova radnja se ne može poništiti.',
    REGENERATE: 'Regeneriši',
    REGENERATE_LINK: 'Regeneriši link',
    SHEET_NOT_FOUND: 'Tabela nije pronađena',
    CLUSTER_NOT_FOUND: 'Klaster nije pronađen',
    PARENT_CLUSTER_NOT_FOUND: 'Nadređeni klaster nije pronađen',
    TAG_NOT_FOUND: 'Tag nije pronađen',
    SHEET_ID_NOT_FOUND: 'Id tabele nije pronađen',
    FAIL_CREATE_ROW: 'Neuspešno kreiranje reda',
    FAIL_CREATE_CLUSTER: 'Neuspešno kreiranje klastera',
    ROW_CREATED: 'Red kreiran',
    COLUMN_CREATED: 'Kolona kreirana',
    DIMENSION_CREATED: 'Dimenzija kreirana',
    NOT_IMPLEMENTED_YET: 'Još uvek nije implementirano',
    VARIABLE_SHOULD_CONTAIN_ONLY_VARIABLES: 'Polje promenljivih treba da sadrži samo promenljive',
    UNKNOWN_ZONE_SINGLE_VALUE: 'Nepoznata zona u jednoj vrednosti',
    FILTER_FIELD_SHOULD_CONTAIN_DIMENSION_TAGS: 'Polje filtera treba da sadrži oznake dimenzije',
    UNKNOWN_ZONE_DATA_EDITOR: 'Nepoznata zona u editoru podataka',
    VARIABLE_FILED_SHOULD_CONTAIN_ACCOUNT_TAG: 'Polje promenljivih treba da sadrži oznake računa',
    CUSTOM_COLUMN_NOT_FOUND: 'Prilagođena kolona nije pronađena',
    CANT_ADD_TO_COLUMN: 'Ne mogu dodati {tagType} u tip kolone {columnType}',
    TAG_ALREADY_ADDED: 'Ova oznaka je već dodana',
    MODEL_IMPORT_IN_PROGRESS: 'Uvoz modela je u toku...',
    MODEL_IMPORT_SUCCESS: 'Model je uspešno uvezen.',
    CODE_EDITOR_ALLOW_CHANGES: 'Dopustite uređivaču koda da napravi promene u modelu:',
    ALLOW_ALL: 'Dopusti sve',
    DELETE_MEMBER_ROWS: 'Obriši redove',
    DELETE_TABLES: 'Obriši tabele',
    DELETE_VARIABLES: 'Obriši varijable',
    DELETE_COLUMNS: 'Obriši kolone',
    DELETE_CELLS: 'Obriši ћелије',
    DELETE_EVERYTHING: 'Obriši sve prilikom primene promena',
    DRY_RUN: 'Suho pokretanje',
    MODEL_CODE_EDITOR: 'Uređivač koda modela',
    MODEL_IMPORT_EXPORT: 'Uvoz/izvoz modela',
    MODEL_IMPORT: 'Uvoz modela',
    MODEL_EXPORT: 'Izvoz modela',
    MODEL_USE_IN_EXPORT: 'Koristi u izvozu',
    MODEL_OBJECT_TYPE: {
        DTAB: 'Dimenzionalne tabele',
        DMEM: 'Članovi dimenzije',
        VAR: 'Varijable',
        CELL: 'Ćelije',
    },
    LOADING: 'Učitavanje...',
    CHAT_STATUS_ANALYZING_CONTEXT: 'Analiziranje vašeg pitanja',
    CHAT_STATS_ACTIONS: '{count} {{radnja|radnje}}',
    CHAT_STATS_CONTEXT: '{tokens} kontekst',
    CHAT_STATS_DURATION_TOOLTIP: 'Koliko je vremena bilo potrebno da se generiše ovaj odgovor',
    CHAT_STATS_ACTIONS_TOOLTIP: 'Koliko je radnji agent izvršio (učitavanje veština, pokretanje koda)',
    CHAT_STATS_CONTEXT_TOOLTIP: 'Trenutna veličina konteksta razgovora. Starije poruke se sažimaju kada postane prevelik.',
    CHAT_DEFAULT_TITLE: 'Razgovor',
    CHAT_ENTER_FULLSCREEN: 'Prikaz na celom ekranu',
    CHAT_EXIT_FULLSCREEN: 'Izađi iz prikaza na celom ekranu',
    CHAT_RENAME: 'Preimenuj razgovor',
    CHAT_DELETE: 'Obriši razgovor',
    CHAT_CREATE_NEW: 'Kreiraj novi razgovor',
    CHAT_MESSAGE_PLACEHOLDER: 'Poruka za FarseerAI...',
    CHAT_SEND: 'Pošalji',
    CHAT_RENAME_TITLE: 'Preimenuj razgovor',
    CHAT_HELP_QUESTION: 'Kako vam mogu pomoći danas',
    CHAT_SUGGESTED: 'Predloženo',
    CHAT_SUGGESTED_SUMMARY: 'Daj mi kratak sažetak modela',
    CHAT_SUGGESTED_DIMENSIONS: 'Postoje li varijable koje imaju više dimenzija od varijabli korišćenih u njihovoj formuli?',
    CHAT_SUGGESTED_DELAY: 'Koriste li neke varijable funkciju delay()?',
    CHAT_SUGGESTED_ON_DEMAND: 'Navedi sve varijable na zahtev',
    CHAT_SUGGESTED_MEASURES: 'Navedi sve mere',
    CHAT_SUGGESTED_FIXED_DIMENSION: 'Navedi sve varijable koje koriste fiksnu dimenziju',
    CHAT_SUGGESTED_DATE_PROPERTY: 'Navedi sve dimenzije koje imaju svojstvo datuma',
    CHAT_CREATED: 'Razgovor stvoren!',
    CHAT_CREATED_NEW: 'Novi razgovor kreiran!',
    CHAT_RENAMED: 'Razgovor preimenovan!',
    CHAT_DELETED: 'Razgovor obrisan!',
    CHAT_FAILED_CREATE: 'Kreiranje novog razgovora nije uspelo.',
    CHAT_FAILED_LOAD: 'Učitavanje razgovora nije uspelo.',
    CHAT_FAILED_RENAME: 'Preimenovanje razgovora nije uspelo.',
    CHAT_FAILED_DELETE: 'Brisanje razgovora nije uspelo.',
    CHAT_FAILED_CANCEL: 'Otkazivanje zahteva nije uspelo.',
    CHAT_FEEDBACK_FAILED: 'Čuvanje povratnih informacija nije uspelo.',
    CHAT_FEEDBACK_THUMBS_UP: 'Dobar odgovor',
    CHAT_FEEDBACK_THUMBS_DOWN: 'Loš odgovor',
    CHAT_FEEDBACK_COMMENT_TITLE: 'Recite nam šta je pošlo po zlu',
    CHAT_FEEDBACK_COMMENT_PLACEHOLDER: 'Šta je bilo korisno ili šta je pošlo po zlu? (opciono)',
    CHAT_FEEDBACK_COMMENT_SAVE: 'Sačuvaj',
    CHAT_FEEDBACK_CLEAR: 'Obriši povratnu informaciju',
    CHAT_AGENT_TYPE_ANALYST: 'Analitičar',
    ADVANCED_SETTINGS: 'Napredne postavke',
    INVALID_JSON_ERROR: 'Neispravan JSON: {message}',
    MAINTENANCE_MODE_CURRENTLY_ENABLED: 'Režim održavanja je trenutno omogućen',
    MAINTENANCE_MODE_ENABLED: 'Režim održavanja je trenutno omogućen',
    CONTACT_ADMIN_FOR_INFO: 'Molimo sačekajte ili kontaktirajte svog administratora za više informacija.',
    RETRY: 'Pokušaj ponovno',
    COPY_LINK: 'Kopiraj link',
    COPY_DATA_FROM: 'Kopiraj podatke iz',
    ROWS_CUT: 'Izrezane redove',
    ROWS_COPIED: 'Kopirani redovi',
    ROWS_MOVED: 'Pomičeni redovi',
    ROWS_PASTED: 'Zalijepljeni redovi',
    CELLS_CUT: 'Izrezane ćelije',
    CELLS_COPIED: 'Kopirane ćelije',
    FAILED_CELLS_COPIED: 'Neuspjelo kopiranje ćelija {message}',
    CANNOT_CELLS_PASTED: 'Ne može se zalijepiti ćelije ovde',
    TAG: 'Oznaka',
    ACTION: 'Akcija',
    MANAGE_CONNECTIONS_FOR: 'Upravljaj vezama za',
    RENAME: 'Preimenuj',
    RENAME_FILE_EXTENSION_REQUIRED: 'Nazivi fajlova moraju imati ekstenziju, kao što su .csv ili .xlsx.',
    RENAME_FILE_EXTENSION_CHANGE_TITLE: 'Promeniti ekstenziju fajla?',
    RENAME_FILE_EXTENSION_CHANGE_QUESTION: 'Ovo menja ekstenziju iz “.{oldExt}” u “.{newExt}”, što može promeniti način na koji se fajl otvara. Nastaviti?',
    REMOVE_COLUMN: 'Ukloni kolonu',
    REMOVE_CONNECTION: 'Ukloni vezu',
    TABLE_CONNECTION: 'Vezivanje tabele',
    TEXT: 'Tekst',
    TEXT_COLUMN: 'Tekst stupac',
    NUMBER: 'Broj',
    NUMBER_COLUMN: 'Broj stupac',
    NEW_NUMBER_COLUMN: 'Novi broj stupac',
    FILE: 'Datoteka',
    FILE_COLUMN: 'Datoteka stupac',
    DATE_COLUMN: 'Datum stupac',
    EDIT_TAG_TYPE: 'Uredi {tagTypeName}',
    DELETE_TAG_TYPE: 'Obriši {tagTypeName}',
    DELETE_TAG_TYPE_DATA: 'Obriši podatke {tagTypeName}',
    CONNECTIONS: 'Veze',
    EDIT_CONNECTIONS: 'Uredi veze',
    CLEAR_FIELD: 'Očisti polje',
    ERROR_CLEAR_FIELD: 'Greška prilikom čišćenja polja',
    REPLACE_FILE: 'Zameni fajl',
    DOWNLOAD_FILE: 'Preuzmi fajl',
    DOWNLOAD_ORIGINAL_FILE: 'Preuzmi originalni fajl',
    FILE_DOES_NOT_EXIST: 'Fajl ne postoji',
    DELETE_FILE: 'Obriši fajl',
    ERROR_DELETE_FILE: 'Greška pri brisanju fajla',
    LOCKS: 'Zaključavanje',
    LOCK_REFERENCES_DELETED_ENTITIES: 'Ovo zaključavanje referencira obrisane entitete',
    TABLE_SETTINGS: 'Postavke tabele',
    NEW_MEMBER: 'Novi član',
    SORT_TABLE: 'Sortiraj tabelu',
    NAME_ASCENDING: 'Ime rastuće',
    NAME_DESCENDING: 'Ime opadajuće',
    ADD_SORT_RULE: 'Dodaj pravilo sortiranja',
    REMOVE_ALL_SORT_RULES: 'Ukloni sva pravila sortiranja',
    '1_SORT': '1 sortiranje',
    N_SORTS: '{count} sortiranja',
    DESCRIPTION_ASCENDING: 'Opis rastuće',
    DESCRIPTION_DESCENDING: 'Opis opadajuće',
    SORTING_DIMENSIONS: 'Sortiranje dimenzija...',
    DIMENSIONS_SORTED: 'Dimenzije sortirane!',
    ERROR_SORTING_DIMENSIONS: 'Greška prilikom sortiranja dimenzija.',
    EDITING_TIMELINE_SLICER: 'Uređivanje slicer {title}',
    CREATE_NEW_TIMELINE_SLICER: 'Kreiraj novi slicer',
    INTERVAL_START: 'Početak intervala',
    INTERVAL_END: 'Kraj intervala',
    FORMAT: 'Format',
    OPERATION: 'Operacija',
    MY_PROFILE_INFORMATION: 'Informacije o mom profilu',
    PROFILE_SETTINGS: 'Podešavanja profila',
    ADD_PHOTO: 'Dodaj fotografiju',
    CHANGE_PHOTO: 'Promeni fotografiju',
    UPDATE_PHOTO: 'Ažuriraj fotografiju',
    REMOVE_PHOTO: 'Ukloni fotografiju',
    DECIMAL_SEPARATOR: 'Decimalni separator',
    DATE_FORMAT: 'Format datuma',
    DATE_SEPARATOR: 'Separator datuma',
    ACCESSIBLE_CHART_PATTERNS: 'Obrasci pristupačnosti za grafikone',
    SET_AS_DEFAULT_PALETTE: 'Postavi kao podrazumevanu paletu',
    SAVE_CURRENT_COLORS_AS_PALETTE: 'Sačuvaj trenutne boje kao paletu',
    DELETE_PALETTE: 'Obriši paletu',
    FILL_STYLE: 'Stil ispune',
    SOLID: 'Puno',
    HATCHED: 'Šrafirano',
    VARIABLE: 'Varijabla',
    DIMENSION: 'Dimenzija',
    CREATE_OR_GENERATE_NEW_ROWS: 'Kreiraj ili generiši nove redove',
    CREATE_ROW_AS: 'Kreiraj {row} kao',
    GENERATE_ROWS_FROM: 'Generiši red(ove) iz',
    CREATE_NEW_VARIABLE: 'Kreiraj novu varijablu',
    ENTER_FORMULA_FOR: 'Unesite formulu za {variableName}',
    SELECT_A_VARIABLE_FORMULA: 'Izaberite varijablu za pregled ili izmenu formule',
    DATABASE_AND_PROPERTIES: 'Baza podataka i svojstva',
    FOLDER_EMPTY: 'Fascikla je prazna',
    DASHBOARD_EMPTY: 'Kontrolna tabla je prazna',
    DASHBOARD_HINT: 'Počnite sa svojim kontrolnim tablama pravljenjem elementa.',
    YEARS_SETTINGS: 'Postavke godina',
    FINANCIAL_YEAR_STARTING_MONTH: 'Početak finansijske godine mesec',
    UPDATING_FINANCIAL_YEAR_STARTING_MONTH: 'Ažuriranje početnog meseca finansijske godine',
    FINANCIAL_YEAR_STARTING_MONTH_UPDATED: 'Početni mesec finansijske godine ažuriran',
    SOMETHING_WENT_WRONG: 'Došlo je do greške.',
    SEARCH_FOR_USERS: 'Pretraži korisnike...',
    SEARCH_FOR_GROUPS: 'Pretraži grupe...',
    SEARCH_BY_GROUP_OR_USER: 'Pretraži po grupi ili korisniku',
    USERS: 'Korisnici',
    GROUPS: 'Grupe',
    USER_OR_GROUP: 'Korisnik/Grupa',
    PERMISSIONS: 'Dozvole',
    END_DATE_MUST_BE_GREATER_THAN_START_DATE: 'Krajnji datum mora biti veći od početnog datuma',
    HISTORY_DATA_CANNOT_OVERLAP_WITH_FORECAST_DATA: 'Istorija podaci ne mogu se preklapati sa podacima prognoze',
    PLEASE_CHOOSE_AN_ACCOUNT_TAG: 'Molimo izaberite oznaku računa',
    ERROR_STARTING_FORECAST: 'Greška pri pokretanju prognoze',
    CUSTOM_FORECAST: 'Prilagođena prognoza',
    HISTORICAL_DATA_FROM: 'Istorija podaci od',
    HISTORICAL_DATA_TO: 'Istorija podaci do',
    SOURCE_VARIABLE_AND_DIMENSIONS: 'Izvor varijabla i dimenzije',
    ERROR: 'Greška {message}',
    FORECAST: 'Prognoza',
    VIEW_FORECASTS_FOR_PERIOD: 'Pogledaj prognoze za period',
    NO_JOBS_FOR_SELECTED_PERIOD: 'Nema poslova za odabrani period',
    ACTIVE_JOBS: 'Aktivni poslovi',
    FINISHED_JOBS: 'Završeni poslovi',
    COMPLETED_ON: 'Završeno {time}',
    FORECAST_PROGRESS: 'Napredak prognoze',
    ERROR_LOADING_FORECAST_JOBS: 'Greška prilikom učitavanja poslova prognoze.',
    PAGE: 'Stranica',
    EDIT_ENTRY: 'Uredi unos',
    NEW_ENTRY_BY_DATE: 'Novi unos po datumu',
    TAGS: 'Oznake',
    ADD_TAG: 'Dodaj oznaku',
    START_YEAR: 'Početna godina',
    START_MONTH: 'Početni mesec',
    END_YEAR: 'Završna godina',
    END_MONTH: 'Završni mesec',
    MUST_SELECT_ROW: 'Morate izabrati red',
    TITLE: 'Naslov',
    SUBTITLE: 'Podnaslov',
    FOOTNOTES: 'Fusnote',
    ROW: 'Red',
    SELECT_ROW: 'Izaberi red',
    COLUMN: 'Kolona',
    ROW_NAME_DISPLAY: 'Prikaz imena reda',
    BOTH: 'Oboje',
    SHARED_COLUMN_CONFIG_PRESET: 'Podešavanje zajedničke konfiguracije stupca',
    SHOW_ZERO_SUM_ROWS: 'Prikaz nula sumiranih redova',
    USE_DATA_FROM_TIMELINE_SLICER: 'Koristi podatke iz vremenskog slicera',
    USE_DATA_FROM_DIMENSION_SLICER: 'Koristi podatke iz slicera dimenzija',
    DELETE_TARGET_AND_RELATED_DATA: 'i povezani podaci?',
    DELETE_TARGET_CHILDREN: 'Obriši decu',
    DELETE_TARGET_DATA: 'Obriši podatke za',
    CONFIRM_DELETE_ROW: 'Izbrisati red?',
    CONFIRM_DELETE_ROWS: 'Izbrisati {count} redova?',
    CONFIRM_DELETE_ROWS_GENERATED: 'Izbrisati generisane redove?',
    CONFIRM_DELETE_ROWS_MIXED: 'Izbrisati redove i generisane redove?',
    EXPLAIN_DELETE_ROW: 'Ovo će izbrisati <>{row}<>',
    EXPLAIN_DELETE_ROWS_GENERATED: 'Ovo će izbrisati generisane redove iz <>{table}<> iz ovog sheeta.',
    EXPLAIN_DELETE_ROWS_MIXED: 'Ovo će izbrisati <>{count} red(ova)<> i generisane redove iz <>{table}<> iz ove proračunske tabele.',
    EXPLAIN_DELETE_ROWS_SUBROWS: 'Ovo će također izbrisati sve podredne redove. Ova radnja se ne može poništiti.',
    FAILED_DELETE_ROW: 'Brisanje reda nije uspelo',
    DELETE_ROW_AND_ITS_CHILDREN_CONFIRMATION: 'i sve njegove podredne redove i stavke?',
    NO_ACCESS_TO_DELETE_ROWS: 'Nemate pristup navedenim redovima, pa ih ne možete izbrisati.',
    CREATE_GROUP: 'Kreiraj grupu',
    EDIT_PERMISSIONS: 'Uredi dozvole',
    USERS_AND_GROUPS_MANAGEMENT: 'Upravljanje korisnicima i grupama',
    SUM: 'Zbir',
    COUNT: 'Broj',
    AVERAGE: 'Prosečno',
    CLOSING_STATE: 'Završno stanje',
    BEGINNING_STATE: 'Početno stanje',
    FORMULA: 'Formula',
    MAX: 'Maksimum',
    MIN: 'Minimum',
    YES: 'Da',
    NO: 'Ne',
    YESTERDAY: 'Juče',
    CONFIRM_VARIABLE_REMOVE: 'Potvrdite uklanjanje varijable',
    CONFIRM_VARIABLES_REMOVE: 'Potvrdite uklanjanje varijabli',
    REMOVE_VARIABLE_CONFIRMATION: 'Da li ste sigurni da želite ukloniti varijablu',
    REMOVE_VARIABLES_CONFIRMATION: 'Da li ste sigurni da želite ukloniti varijable:',
    REMOVE_VARIABLES_COUNT_CONFIRMATION: 'Da li ste sigurni da želite ukloniti {tagNumber} varijabli?',
    EDIT_VARIABLE: 'Uredi varijablu',
    SHARE_VARIABLE: 'Podeli varijablu',
    DELETE_VARIABLE_DATA: 'Obriši podatke varijable',
    DELETE_VARIABLE: 'Obriši varijablu',
    EXPAND_MORE: 'Proširi više',
    COLLAPSE_ALL: 'Skupi sve',
    VARIABLE_METRICS: 'Metrike varijable',
    VARIABLE_TABLE_COLUMNS: {
        Name: 'Ime',
        Description: 'Opis',
        Formula: 'Formula',
        Dimensions: 'Dimenzije',
        'Read-only': 'Read only',
        'Roll-up type': 'Tip uvrštavanja',
    },
    LOADING_DATA: 'Učitavanje podataka…',
    SUCCESSFULLY_LOADED_DATA: 'Podaci učitani',
    LOADING_DATA_FAILED: 'Nije moguće učitati podatke',
    LOADING_DATA_FAILED_SUBTITLE: 'Pokušajte da osvežite stranicu',
    WAITING: 'Čekanje...',
    VIEW_LOGS: 'Prikaži zapise',
    LOADING_DATA_LOG: 'Zapisnik učitavanja podataka',
    CALCULATION_STARTED: 'Početak izračunavanja',
    CALCULATION_FINISHED: 'Izračunavanje završeno',
    DATABASE_LOADED: 'Baza podataka učitana. Broj učitanih ćelija: {numberOfCells}',
    VARIABLE_CALCULATION_STARTED: 'Počelo izračunavanje varijable {variableName}. Broj ulaznih ćelija: {numberOfCells}',
    VARIABLE_CALCULATION_ENDED: 'Izračunavanje varijable {variableName} završeno. Broj ćelija: {numberOfCells}, faktor izlaz/ulaz: {outInFactor}.',
    NEW_ROW: 'Novi red',
    NEW_TEMPLATE_OR_ROW: 'Novo',
    ADD_TEMPLATE_TO_TOOLBAR: 'Dodaj na traku alata',
    REMOVE_TEMPLATE_FROM_TOOLBAR: 'Ukloni sa trake alata',
    IN_TOOLBAR: 'Na traci alata',
    TEMPLATE_ADDED_TO_TOOLBAR: 'Šablona dodana na traku alata',
    TEMPLATES: 'Šabloni',
    SELECT_A_ROW: 'Izaberi red',
    FILE_CANT_BE_PREVIEWED: 'Datoteka se ne može pregledati',
    THIS_TYPE_OF: 'Ovaj tip',
    INPUT_SETUP: 'Postavke ulaza',
    ONDEMAND_CALCULATION: 'Proračun po zahtevu',
    REFRESH_DATA: 'Osveži podatke',
    DISABLE_MAINTENANCE_MODE: 'Onemogući režim održavanja',
    ENABLE_MAINTENANCE_MODE: 'Omogući režim održavanja',
    SAVED: 'Sačuvano',
    FORMULA_ERROR: 'Greška u formuli',
    UNEXPECTED: 'Neočekivano',
    INVALID_SYNTAX: 'Neispravna sintaksa za',
    MISSING_TOKEN_AFTER: 'Nedostaje token nakon',
    UNNECESSARY: 'Nepotrebno',
    ERROR_MESSAGE_OCCURRED: 'Došlo je do greške',
    INCOMPLETE_sheet_ITEM_DATA: 'Nepotpuni podaci o stavkama',
    FAIL_SAVE_sheet_ITEMS: 'Neuspelo čuvanje stavki',
    HEADER_COLUMNS: {
        Description: 'Opis',
        Date: 'Datum',
        Version: 'Verzija',
        'Variable and Dimensions': 'Varijabla i dimenzije',
        Value: 'Vrednost',
        'Value type': 'Vrsta vrednosti',
        Action: 'Akcija',
    },
    DESCRIPTION_UPDATE_DATE_TAGS_FAILED: 'Ažuriranje opisa za mesečne i godišnje oznake nije uspelo.',
    COMPARISON: 'Upoređivanje',
    DISALLOW: 'Onemogući',
    USE_DEFAULT: 'Koristi podrazumevano',
    SKIP_ROW: 'Preskoči red',
    MISSING_MEMBERS_IMPORT_NOT_ALLOWED: 'Neće dozvoliti uvoz dok postoje nepostojeći članovi.',
    MISSING_MEMBERS_SKIP_ROWS: 'Preskoči redove sa nepostojećim članovima.',
    MISSING_MEMBERS_DEFAULT: 'Uvoziti podatke iz nepostojećih članova u podrazumevanog člana tabele.',
    CONFIGURE_JOB_OPTIONS: 'Konfiguriši opcije posla',
    HANDLE_MISSING_DIMENSION_MEMBERS: 'Upravljaj nedostajućim članovima dimenzije',
    IMPORT_ZEROS: 'Uvoz nula',
    OVERWRITE_CELLS: 'Prepisi ćelije',
    IGNORE_FINANCIAL_YEAR_OFFSET: 'Ignoriši pomeranje finansijske godine',
    SKIP_EMPTY_ROWS: 'Preskoči prazne redove',
    SKIP_REPEATING_HEADER_ROWS: 'Preskoči ponavljajuće redove zaglavlja',
    SKIP_LOW_SIGNAL_ROWS_HEURISTIC: 'Preskoči redove sa malo informacija (heuristika)',
    ROWS_WILL_BE_SKIPPED_ON_IMPORT: '{count} red(ova) će biti preskočeno pri uvozu.',
    NO_ROWS_WILL_BE_SKIPPED_ON_IMPORT: 'Nijedan red neće biti preskočen pri uvozu.',
    INCLUDE_IN_IMPORT: 'Uključi u uvoz',
    EXCLUDE_FROM_IMPORT: 'Isključi iz uvoza',
    MISSING_MEMBERS_REPLACE_ALL: 'Zameni sve prethodne članove dimenzije',
    MISSING_MEMBERS_REPLACE_ALL_CONFIRMATION: 'Da li ste sigurni da želite zameniti sve prethodne članove dimenzije?',
    APPLY_MEMBERS_AND_VARIABLES_TO_VALUE_COLUMNS: 'Primeni članove i varijable na vrednosne kolone',
    WRONG_RESULT_TYPE_FOR_COLUMN: 'Dobijen je pogrešan tip rezultata za kolonu {columnKey}',
    TRIED_TO_ADD_NON_UNIQUE_TAGS: 'Pokušano je dodavanje nejedinstvenih tagova',
    TRIED_TO_CREATE_TAG_WITH_EMPTY_NAME: 'Pokušano je kreiranje taga sa praznim imenom',
    NO_PARENT_TAG_SELECTED: 'Nije izabran roditeljski tag',
    COLUMN_MANAGER: 'Kolone',
    NO_COLUMNS: 'Nema kolona.',
    NEW_COLUMN_TIP: 'Možete početi dodavanjem novog elementa kolone. Zatim koristite bočnu traku za odabir i kreiranje prilagođenih kolona.',
    NEW_COLUMN: 'Novi kolona',
    COLUMN_TO_NUMBER_TYPE: 'Promeni u broj',
    COLUMN_TO_COMPARISON_TYPE: 'Promeni u poređenje',
    COMPARISON_OPERATION: 'Operacija',
    DROP_ELEMENTS: 'Odbaci elemente...',
    READONLY: 'Samo za čitanje',
    CUSTOM_TITLE: 'Prilagođeni naslov',
    SELECT_ROW_TO_DROP_ELEMENTS: 'Izaberite red za odbacivanje elemenata',
    CANT_MOVE_ROW_INSIDE_SELF: 'Ne možete premestiti red unutar samog sebe',
    CLEAR_ALL: 'Očisti vše',
    MIGRATE_TO_SHEET: 'Migriraj na proračunsku tabelu',
    CHOOSE_TIME_PERIOD: 'Molim odaberite vremenski period',
    NO_VARIABLE: 'Nema varijable',
    NO_ROWS_SELECTED: 'Nema izabranih redova',
    STARTING_YEAR_NOT_ACTIVE: 'Početna godina nije aktivna',
    SHEET: 'Proračunska tabela',
    ASSIGNEE: 'Dodeljeni',
    APPROVER: 'Odobravatelj',
    SHARED_TO: 'Deljeno s',
    PUBLIC: 'Javno',
    PUBLIC_LINK: 'Javna veza',
    VERSIONS_AND_INTERVAL: 'Verzije i interval',
    INTERVAL: 'Interval',
    EXPIRES_IN: 'Ističe za',
    STATUS: 'Status',
    STATUS_EXPIRES_IN: 'Status (Ističe za)',
    PUBLIC_ASSIGNMENT_LINK_COPIED_TO_CLIPBOARD: 'Veza javnog zadatka kopirana u međuspremnik',
    EXPORTING: 'Izvoz...',
    APPROVE: 'Odobri',
    DISAPPROVE: 'Odbij',
    EXPORT: 'Izvezi',
    EXPIRE: 'Istekni',
    REFRESH: 'Osveži',
    NO_ASSIGNMENTS_AVAILABLE: 'Nema dostupnih zadataka',
    MARK_IN_REVIEW: 'Označi kao u pregledu',
    MARK_AS_UNRESOLVED: 'Označi kao nerešeno',
    MARK_AS_RESOLVED: 'Označi kao rešeno',
    GO_TO_ROW: 'Idi na red',
    DELETE_THREAD: 'Izbriši nit',
    REPLAY_OR_TAG_IN_COMMENT: 'Odgovori ili označi druge s @...',
    COMMENT_OF: 'Komentar {arrowsCurrent} od {arrowsAll}',
    COMMENT: 'Komentar',
    COMMENTS: 'Komentari',
    LOADING_IMPORT_JOBS: 'Učitavanje poslova uvoza',
    IMPORT_ROWS_TRUNCATED_WARNING: 'Skup podataka je prevelik za potpuni prikaz. Prikazano je samo prvih 200.000 redova. Svi redovi će biti uvezeni kada potvrdite.',
    SELECTED_JOB_DOESNT_EXIST: 'Odabrani posao ne postoji',
    GO_BACK_TO_IMPORT: 'Vrati se na uvoz',
    BACK_TO_IMPORT: 'Nazad na uvoz',
    AT_LEAST_ONE_CHART_LINE: 'Morate dodati barem jednu liniju grafikona.',
    AT_LEAST_ONE_X_AXIS_TAG: 'Morate dodati barem jednu oznaku osi x',
    VISUALIZATION_TYPE: 'Tip vizualizacije',
    VISUALISATION_OPTIONS: 'Opcije vizualizacije',
    EDIT_CHART: 'Uređivanje grafikona "{title}"',
    BAR_CHART: 'Stubičasti grafikon',
    BAR: 'Stubac',
    STACKED_BAR_CHART: 'Naslagani stubičasti grafikon',
    STACKED_BAR: 'Naslagani stubac',
    WATERFALL_CHART: 'Vodopadni grafikon',
    WATERFALL: 'Vodopad',
    PIN_CHART: 'Čioda grafikon',
    PIN: 'Čioda',
    AREA_CHART: 'Površinski grafikon',
    AREA: 'Površina',
    STACKED_AREA_CHART: 'Naslagani površinski grafikon',
    STACKED_AREA: 'Naslagana površina',
    LINE_CHART: 'Linijski grafikon',
    LINE: 'Linija',
    COMBO_CHART: 'Kombinovani grafikon',
    PIE_CHART: 'Tortni grafikon',
    TRAFFIC_LIGHT: 'Semafor',
    INDICATOR: 'Pokazivač',
    SINGLE_VALUE: 'Pojedinačna vrednost',
    CREATE_CHART: 'Stvori novi grafikon',
    ORIENTATION_LAYOUT: 'Orijentacija i raspored',
    HORIZONTAL: 'Horizontalno',
    VERTICAL: 'Vertikalno',
    SINGLE: 'Pojedinačno',
    GRID: 'Mreža',
    THIN: 'Tanko',
    THICK: 'Debelo',
    DOUBLE: 'Dvostruko',
    DOT: 'Tačka',
    CIRCLE: 'Krug',
    SQUARE: 'Kvadrat',
    CATEGORY_AXIS: 'Osa kategorija',
    DOMAIN_AXIS: 'Osa domena',
    SHOW_TOTALS: 'Prikaži ukupno',
    SHOW_AXIS: 'Prikaži os',
    SHOW_VALUE_AXIS: 'Prikaži osu vrednosti',
    SHOW_CATEGORY_AXIS_LABELS: 'Prikaži oznake ose kategorija',
    LABEL_FORMAT: 'Format oznake',
    SHOW_LEGEND: 'Prikaži legendu',
    SHOW_INTEGRATED_LEGEND: 'Prikaži integrisanu legendu',
    VALUE_LABELS: 'Oznake vrednosti',
    ROW_VALUE_LABELS: 'Oznake vrednosti redova',
    SHOW_VALUE_LABELS: 'Prikaži oznake vrednosti',
    POSITION: 'Pozicija',
    SMART_FILTERING: 'Pametno filtriranje',
    TRANSPOSE_DATA: 'Koristi kolone kao serije',
    NORMALIZE_TO_PERCENT: 'Normalizuj na 100%',
    SHOW_EMPTY_ROWS: 'Prikaži prazne redove',
    SHOW_EMPTY_COLUMNS: 'Prikaži prazne kolone',
    GROUP_BY_PARENT_ROW: 'Grupiši po nadređenom redu',
    ACCUMULATE_DATA: 'Izračunaj tekući zbroj',
    COLOR_BY_VALUE: 'Oboj prema vrednosti',
    COLOR_BY_TREND: 'Oboj prema trendu',
    COLOR_TOTALS_BY_VALUE: 'Oboji ukupne vrednosti prema vrednosti',
    USE_SHARED_SCALE: 'Koristi zajedničku skalu',
    STATIC: 'Statično',
    BY_VALUE: 'Prema vrednosti',
    BY_TREND: 'Prema trendu',
    BAR_SPACING: 'Razmak stubaca',
    GAP: 'Razmak',
    WIDTH: 'Širina',
    USE_DATA_FROM_DIMENSION_SLICERS: 'Koristi podatke iz slicera dimenzija',
    X_AXIS_DIMENSION_BUILDER: 'Graditelj dimenzija osi X',
    ADD_REMOVE_X_AXIS_COLUMN: 'Dodaj/ukloni kolonu osi x',
    Y_AXIS_ITEMS: 'Stavke osi Y',
    ADD_CHART_LINE: 'Dodaj liniju grafikona',
    UNLOCK_HIERARCHY: 'Otključaj hijerarhiju',
    LOCK_HIERARCHY: 'Zaključaj hijerarhiju',
    MATERIALIZE: 'Materijaliziraj',
    MORE_OPTIONS: 'Više opcija',
    LOCK_ROW: 'Zaključaj red',
    LOCK_COLUMN: 'Zaključaj kolonu',
    PASTE: 'Zalijepi',
    COPY: 'Kopiraj',
    CUT: 'Izreži',
    PASTE_ROWS: 'Zalijepi red(ove)',
    COPY_ROWS: 'Kopiraj red(ove)',
    CUT_ROWS: 'Izreži red(ove)',
    MOVING_ROWS: 'Premeštanje redova...',
    PASTING_ROWS: 'Lepljenje redova...',
    CONFIRM_LOCK: 'Potvrdi zaključavanje',
    CONFIRM_UNLOCK: 'Potvrdi otključavanje',
    CONFIRM_LOCK_AND_CHILDREN: 'Da li ste sigurni da želite zaključati ovaj red i njegove podredove?',
    CONFIRM_UNLOCK_AND_CHILDREN: 'Da li ste sigurni da želite otključati ovaj red i njegove podredove?',
    SEARCH_FOR_IMPORTS: 'Pretraži uvoze',
    NEW_IMPORT: 'Novi uvoz',
    IMPORTER: 'Uvoznik',
    CREATION_DATE: 'Datum stvaranja',
    ACTIONS: 'Radnje',
    ADD_ACTION: 'Dodaj radnju',
    ADD_ARGUMENT: 'Dodaj argument',
    EDIT_ACTION: 'Uredi radnju',
    ACTION_NAME: 'Naziv radnje',
    ARCHIVE: 'Arhiviraj',
    REPLACE: 'Zameni',
    STATUS_MESSAGE_MAP: {
        'In progress': 'U teku',
        Commited: 'Započeto',
        Archived: 'Arhivirano',
        Reverted: 'Vraćeno',
    },
    EDIT_TILE: 'Uredi element',
    FOCUS_TILE: 'Fokusiraj element',
    UNFOCUS_TILE: 'Poništi fokus elementa',
    MOVE_TO: 'Premjesti u',
    ADD_ROW: 'Dodaj red',
    ADD_COLUMN: 'Dodaj kolonu',
    EDIT_ROW: 'Uredi red',
    FROM: 'Od',
    TO: 'Do',
    GLOBAL_FORMATTING: 'Globalno formatiranje',
    FAIL_SAVE_CHANGES: 'Neuspješno spremanje promjena.',
    TAG_NAME_EXISTS: 'Ime oznake već postoji.',
    MUST_CHOOSE_TYPE: 'Morate odabrati vrstu',
    MUST_ENTER_TAG_NAME: 'Morate unijeti ime oznake',
    TAG_NAME_CANT_CONTAIN_QUOTATION_MARKS: 'Ime oznake ne može sadržavati navodnike.',
    INVALID_VARIABLE_TAG_FORMAT: 'Nevažeći format oznake varijable: {tagFormat}',
    INVALID_FORMULA: 'Nevažeća formula.',
    FUNCITON_NOT_ALLOWED_ON_DIMENSION_TAGS: 'Funkcija {image} nije dopuštena na oznakama dimenzija.',
    CREATE_DATABASE_OBJECT: 'Kreiraj objekt baze podataka',
    EDIT_TAG_TYPE_NAME: 'Uredi {tagType} "{tagName}"',
    PARENT: 'Roditelj',
    ROOT: 'Korijen',
    SEARCH_OR_SELECT_PARENT_TAG: 'Pretraži ili odaberi oznaku roditelja',
    ROLLUP_TYPE: 'Tip sabiranja',
    DATA_TYPE: 'Tip podataka',
    FORMAT_TYPE: 'Tip formata',
    CHOOSE_FORMATTING_OPTION: 'Odaberite opciju formatiranja',
    ENTER_CUSTOM_FORMAT: 'Unesite prilagođeni format',
    CUSTOM_FORMAT: 'Prilagođeni format',
    TOP_DOWN: 'Top down',
    TOP_DOWN_DATA_MAPPING: 'Top down mapiranje podataka',
    CONNECTED: 'Povezan',
    ADD_CONNECTED_VARIABLE: 'Dodaj povezanu varijablu',
    REVERSE_CONNECTED: 'Obrnuto povezano',
    ADD_REVERSE_CONNECTED_VARIABLE: 'Dodaj obrnuto povezanu varijablu',
    DIMENSIONS: 'Dimenzije',
    ADD_DIMENSION: 'Dodaj dimenziju',
    ADVANCED: 'Napredno',
    CALCULATE_ON_DEMAND: 'Izračunaj po zahtevu',
    TRIGGER_ON_DEMAND_CALCULATION: 'Za pokretanje izračunavanja po zahtevu, idite na "Input Setup"',
    OPTIMIZE_CALCULATION: 'Optimizuj izračun',
    CONSTRAINED_LIGHT_TOP_DOWN: 'Ograničeni lagani top down',
    USE_HIERARCHY_IN_CALCULATION: 'Koristi hijerarhiju u izračunu',
    MAPPING_TO_VARIABLE: 'Mapiranje na varijablu',
    ADD_FROM_VERSION: 'Dodaj iz verzije',
    MAPPING_FROM_VERSION: 'Mapiranje iz verzije',
    MAPPING_TO_VERSION: 'Mapiranje na verziju',
    ADD_TO_VERSION: 'Dodaj u verziju',
    USED_IN_FORMULA: 'Korišćen u 1 formuli',
    USED_IN_FORMULAS: 'Korišćen u {numberOfTags} formula',
    TABLE_BACKLINKS: 'Referencirano iz {{1 tabele|?? tabela}}',
    VARIABLE_BACKLINKS: 'Koristi se u {{1 promenljivoj|?? promenljivih}}',
    ACTIVE: 'Aktivan',
    CONNECTED_DIMENSION: 'povezanu dimenziju',
    MY_ACCOUNT: 'Moj nalog',
    SIGN_OUT: 'Odjava',
    LOG_OUT: 'Odjava',
    EDIT_PROFILE: 'Uredi profil',
    FARSEER_AI: 'FarseerAI',
    FARSEER_LABS: 'Farseer Labs',
    PROFILE_AND_SUPPORT: 'Profil i podrška',
    RENAME_TABLE: 'Preimenuj tabelu',
    SHARE_TABLE: 'Podeli tabelu',
    DELETE_TABLE_DATA: 'Obriši podatke u tabeli',
    DELETE_TABLE_MEMBERS: 'Obriši članove tabele',
    DELETE_TABLE_DIMENSIONS: 'Obriši dimenzije tabele',
    DELETE_TABLE: 'Obriši tabelu',
    DELETE_ROW: 'Obriši red',
    DELETE_ROWS: 'Obriši red(ove)',
    SHOW_VALUE: 'Prikaz vrednosti',
    SHOW_VARIABLES_AND_DIMENSIONS: 'Prikaz varijabli i dimenzija',
    FREEZE_ROW_COLUMNS: 'Zamrzni redove/kolone',
    HIDE_GRIDLINES: 'Sakrij mrežne linije',
    HIDE_ROW_COLUMN_HEADERS: 'Sakrij zaglavlja redova/kolona',
    LABELS: 'Oznake',
    ADD_LABEL: 'Dodaj oznaku',
    ERROR_LABEL_EXISTS: 'Oznaka već postoji!',
    ERROR_RENAMING_IMPORT_JOB_LABEL: 'Greška prilikom preimenovanja oznake uvoznog posla!',
    IMPORT_JOB_LABEL_RENAMED: 'Oznaka uvoznog posla preimenovana',
    ERROR_DELETING_IMPORT_JOB_LABEL: 'Greška prilikom brisanja oznake uvoznog posla!',
    IMPORT_JOB_LABEL_DELETED: 'Oznaka uvoznog posla obrisana',
    CREATE_OR_SEARCH: 'Kreiraj ili pretraži..',
    CREATE: 'Kreiraj',
    NAME_AND_DESCRIPTION: 'Naziv i opis',
    SUBTOTALS: 'Subtotali',
    TOTAL: 'Ukupno',
    DISABLED: 'Onemogućen',
    BEFORE: 'Pre',
    AFTER: 'Posle',
    UNSELECT_ALL: 'Poništi odabir',
    SAVE_CONFIG_FOR_ALL: 'Sačuvaj za sve',
    SAVE_CONFIG_FOR_ALL_TOOLTIP: 'Sačuvaj promene konfiguracije kao podrazumevane',
    EDIT_DIMENSION_SLICER: 'Uređivanje dimenzionalnog slica "{title}"',
    CREATE_DIMENSION_SLICER: 'Kreiraj novi dimenzionalni slica',
    ENABLE_MULTISELECT: 'Omogući višestruki izbor',
    DISPLAY_MULTIPLE_VALUES: 'Prikaži višestruke vrednosti',
    SEARCH_AND_AUTO_SELECT: 'Pretraži i automatski izaberi',
    BLANKS: '(Prazno)',
    ENTER_TITLE: 'Unesite naslov...',
    TAG_NAME_DISPLAY: 'Prikaz imena oznake',
    FILTERS: 'Filteri',
    ADD_FILTER: 'Dodaj filter',
    BY_DIMENSION: 'Po dimenzijama',
    SHOW_ONLY_DIMENSIONS_WITH_DATA_IN: 'Prikaz samo dimenzija sa podacima',
    EDIT_SINGLE_VALUE: 'Uređivanje pojedinačne vrednosti "{title}"',
    CREATE_SINGLE_VALUE: 'Kreiraj novu pojedinačnu vrednost',
    LEAVE_EMPTY_FOR_AUTOGENERATED: 'Ostaviti prazno za automatsko generisanje',
    FILTER_DIMENSIONS: 'Filtriraj dimenzije',
    COMPARISON_DIMENSIONS: 'Dimenzije za poređenje',
    COMPARISON_CUSTOM_TEXT: 'Prilagođeni tekst za poređenje',
    DATA_ENTRY: 'Unos podataka',
    SHOW_BUTTONS: 'Prikaz dugmadi',
    STEP: 'Korak',
    AND: 'i',
    DOWNSTREAM_FILTERS: 'Filtri nizvodno',
    TO_TABLE: 'U tabelu',
    FROM_TABLE: 'Iz tabele',
    ADD_DOWNSTREAM_FILTER: 'Dodaj nizvodni filter',
    FLAT: 'Ravno',
    HIERARCHY_MAX_DEPTH: 'Maksimalna dubina hijerarhije',
    APPLICATION_VERSION: 'Verzija aplikacije',
    CONFIRM_TAG_REMOVE: 'Potvrdi uklanjanje taga',
    CONFIRM_TAGS_REMOVE: 'Potvrdi uklanjanje tagova',
    REMOVE_TAG_CONFIRMATION: 'Da li ste sigurni da želite da uklonite tag {tagName}?',
    REMOVE_TAGS_CONFIRMATION: 'Da li ste sigurni da želite da uklonite tagove: {tagNames}?',
    REMOVE_TAGS_NUMBER_CONFIRMATION: 'Da li ste sigurni da želite da uklonite {tagNumber} tagova?',
    ERROR_PARSING_NUMBER: 'Greška prilikom parsiranja broja',
    ERROR_PARSING_DATE: 'Greška prilikom parsiranja datuma',
    USE_CONTEXT_MENU_FOR_UPDATING_FILE_COLUMN: 'Molimo koristite kontekstni meni za ažuriranje kolone datoteke',
    ERROR_PARSING_INPUT_NUMBER: 'Greška prilikom parsiranja unosa broja',
    ERROR_SAVING_DATA: 'Greška prilikom čuvanja podataka',
    DATA_ENTRY_NOT_ALLOWED: 'Unos podataka nije dozvoljen',
    ERROR_PARSING_STEP_VALUE: 'Greška prilikom parsiranja vrednosti koraka',
    TAG_NAME_CELLS: '{tagName}: {cellNumber} ćelija',
    UNKNOWN_VARIABLE_CELLS: 'Nepoznata varijabla: {cellNumber} ćelija',
    SUCCESS_IMPORTED_CELLS: 'Uspešno! Uvezeno ćelija: {accountTags}',
    IMPORTED_CELLS: 'Uvezeno ćelija',
    IMPORT_JOB_DELETING: 'Brisanje uvoznog posla',
    IMPORT_JOB_DELETING_CONFIRM: 'Da li ste sigurni da želite da obrišete uvozni posao {importJobName}?',
    DELETE_AND_KEEP_DATA: 'Obrisati i zadržati podatke',
    DELETE_JOB_AND_DATA: 'Obrisati posao i podatke',
    ADD_DIMENSIONS_TO_JOB: 'Dodaj dimenzije poslu',
    CONFIGURE: 'Konfiguriši',
    ADD_DESCRIPTION_FOR_IMPORT: 'Dodaj opis za ovaj uvoz',
    UNDO: 'Poništi',
    SETTINGS: 'Podešavanja',
    BASIC_SETTINGS: 'Osnovna podešavanja',
    OTHER_SETTINGS: 'Ostala podešavanja',
    TABLE_NAME: 'Ime tabele',
    AUTOGENERATE_DIMENSION_NAMES: 'Automatsko generisanje imena dimenzija',
    AUTOGENERATE_NAMES_CONFIG: 'Konfiguracija automatskog generisanja imena',
    AUTOGENERATE_NAMES_CONFIG_EXAMPLE: 'npr. {SSS}-{YY}#{DD}',
    CUSTOM_TEMPLATE_DESCRIPTION: 'Definišite prilagođenu konfiguraciju za automatsko generisanje imena za ovu tabelu. Koristite predefinisane oznake ispod sa vitičastim zagradama. Možete staviti bilo koji znak između oznaka.',
    USE_TOKENS_TO_DEFINE_CONFIG: 'Možete koristiti ove oznake za definisanje konfiguracije',
    AUTOGENERATE_CONFIG_EXAMPLE: '{SSS}-{YY}#{MM}_{DD}',
    AUTOGENERATE_CONFIG_EXAMPLE_DATE: '- 001-23#03_20 (ožujka 20, 2023.)',
    ENTRY: 'Unos',
    STEP_MUST_BE_NUMBER: 'Korak mora biti broj',
    EDIT_DATA_EDITOR: 'Uređivanje uređivača podataka "{title}"',
    BUTTON_CONTROLS: 'Kontrole dugmeta',
    BOLD: 'Podebljano',
    ITALIC: 'Kurziv',
    UNDERLINED: 'Podvučeno',
    OUTLINED: 'Obrub',
    FONT_SIZE: 'Veličina fonta',
    FILE_SIZE: 'Veličina datoteke',
    SMALL: 'Malo',
    MEDIUM: 'Srednje',
    LARGE: 'Veliko',
    CREATE_NEW_COLUMN: 'Kreiraj novu kolonu',
    EDIT_COLUMN_WITH_LABEL: 'Uredi kolonu "{label}"',
    COLUMN_TAGS: 'Oznake kolone',
    DELETE_THIS_COLUMN: 'Obriši ovu kolonu',
    SELECT_PARENT_TAG_TO_GENERATE_COLUMNS: 'Izaberite roditeljsku oznaku za generisanje više kolona',
    USING_SHARED_COLUMN_CONFIG: 'Koristi zajedničku konfiguraciju kolone',
    SLICER_GENERATED: 'Slicer generisan',
    HEADER_CANNOT_BE_EMPTY: 'Zaglavlje ne može biti prazno',
    MUST_CHOOSE_A_FORMAT: 'Morate odabrati format',
    CALCULATION_FIELDS_CANT_BE_EMPTY: 'Polja za izračunavanje ne mogu biti prazna',
    ADD_NEW_COLUMN: 'Dodaj novu kolonu',
    HEADER: 'Zaglavlje',
    SUBHEADER: 'Podnaslov',
    TYPE: 'Tip',
    POLARITY: 'Polaritet',
    CONDITIONAL_FORMATTING: 'Uslovno formatiranje',
    CONDITIONAL_FORMATTING_TYPE_OPTIONS: {
        Relative: 'Relativno',
        Absolute: 'Apsolutno',
    },
    CONDITIONAL_FORMATTING_POLARITY_OPTIONS: {
        Positive: 'Pozitivno',
        Negative: 'Negativno',
        Neutral: 'Neutralno',
    },
    KPI_COLUMN_TYPE_META: {
        Regular: 'Regularno',
        Calculated: 'Izračunato',
    },
    CONDITIONAL_FORMATTING_OPTIONS: {
        Off: 'Isključeno',
        Traffic: 'Semafori',
        Databar: 'Traka podataka',
        Colorscale: 'Skala boja',
        Arrows: 'Strelice',
    },
    HIDE_NUMBERS: 'Sakrij brojeve',
    COLUMN_ONE: 'Kolona 1',
    COLUMN_TWO: 'Kolona 2',
    LITERAL: 'literal',
    FUNCTION: 'funkcija',
    FUNCTIONS: 'Funkcije',
    EXAMPLE: 'Primer',
    EDIT_IN: 'Uredi {type}',
    OPEN_IN_EDITOR: 'Otvori u {type} editor',
    REMOTE_JOBS_DATE_TIME_MESSAGE: 'Svake nedelje u {day} u {time}',
    REMOTE_JOB_SCHEDULED: 'Zakazano {schedule}',
    SCHEDULE: 'Raspored',
    EVERY: 'Svaki',
    EVERY_HOUR_AT: 'Svaki sat u',
    EVERY_DAY_AT: 'Svaki dan u',
    RUN_JOB: 'Pokreni posao',
    RUN: 'Pokreni',
    QUEUED: 'U redu',
    RUNNING: 'Izvršavanje...',
    UNAVAILABLE: 'Nedostupno',
    MINUTES: 'minuta',
    JOBS: 'Poslovi',
    JOB_LOGS: 'Logovi posla',
    PREFERRED_RUNNER: 'Preferirani izvođač',
    RUNNER_DISCONNECTED: 'Ovaj izvođač trenutno nije povezan.',
    RUNNER_IMAGE: 'Slika izvođača',
    RUNNER_IMAGE_TAG: 'Verzija',
    LOGS: 'Logovi',
    REMOTE_JOBS: 'Aplikacije',
    TAG_INTERNAL_TYPE_NAME: {
        Version: 'Verzija',
        Year: 'Godina',
        Month: 'Mesec',
        Quarter: 'Kvartal',
        'Half Year': 'Polugodište',
        'Year to Date': 'Od početka godine',
    },
    VARIABLE_TABLE_DIMENSION_GROUP: 'Varijabla/Tabela/Dimenzija/Grupa',
    ADD_NEW_VARIABLE_TABLE_DIMENSION_GROUP: 'Dodaj novi {item}',
    DATA_TYPE_ENUM: {
        Integer: 'Ceo broj',
        Decimal: 'Decimalni',
    },
    DEFAULT_FORMAT_TYPE_ENUM: {
        Custom: 'Prilagođeno',
        Number: 'Broj',
        Currency: 'Valuta',
        Percentage: 'Procenat',
        Date: 'Datum',
    },
    HEADER_NAVIGATION: {
        Dashboard: 'Nadzorna tabla',
        Sheets: 'Proračunske tabele',
        Import: 'Uvoz',
        'Remote jobs': 'Aplikacije',
        Dimensions: 'Dimenzije',
    },
    ENTITY_TYPE: {
        DIMENSION_TABLE: 'Dimenzionalna tabela',
        DIMENSION_MEMBER: 'Član dimenzije',
        VARIABLE: 'Varijabla',
        FOLDER: 'Fascikla',
        FUNCTION: 'Funkcija',
        LITERAL: 'Literal',
        PROPERTY: 'Svojstvo',
        FILE: 'Datoteka',
        DASHBOARD: 'Kontrolna tabla',
        REMOTE_JOB: 'Aplikacija',
        SHEET: 'Proračunska tabela',
        TILE: 'Element',
    },
    ENTITY_TYPES: {
        DIMENSION_TABLE: 'Dimenzionalne tabele',
        DIMENSION_MEMBER: 'Članovi dimenzije',
        VARIABLE: 'Varijable',
        FOLDER: 'Fascikle',
        FUNCTION: 'Funkcije',
        LITERAL: 'Literali',
        PROPERTY: 'Svojstva',
        FILE: 'Datoteke',
        DASHBOARD: 'Kontrolne table',
        REMOTE_JOB: 'Aplikacije',
        SHEET: 'Proračunske tabele',
        TILE: 'Elementi',
    },
    ITEM: 'Stavka',
    ITEM_TYPE: 'Tip stavke',
    FOLDER_ITEM: {
        DASHBOARD: 'Kontrole',
        DIMENSION_TABLE: 'Tabele dimenzija',
        VARIABLE: 'Varijable',
        SHEET: 'Tabele',
        FOLDER: 'Fascikli',
        FARSEER_FILE: 'Datoteke',
        REMOTE_JOB: 'Aplikacije',
    },
    FOLDER_ITEMS: {
        DASHBOARD: 'Kontrole',
        DIMENSION_TABLE: 'Tabele dimenzija',
        VARIABLE: 'Varijable',
        SHEET: 'Tabele',
        FOLDER: 'Fascikli',
        FARSEER_FILE: 'Datoteke',
        REMOTE_JOB: 'Aplikacije',
    },
    TABLE_SETTINGS_TEMPLATE_PATTERNS: {
        UUID: 'generiše univerzalni jedinstveni identifikator',
        YYYY: 'umetne trenutnu godinu',
        YY: 'umetne poslednje dve cifre trenutne godine',
        MM: 'umetne trenutni mesec',
        DD: 'umetne trenutni dan',
        SSSSSSSS: 'umetne serijski broj dužine trenutne tabele + 1, definišite dužinu prema broju karaktera "S" (1-8)',
    },
    CONFIG_MENU_SECTIONS: {
        'Users & Permissions': 'Korisnici i dozvole',
        'Users & Groups': 'Korisnici i grupe',
        System: 'Sistem',
        'Input Setup': 'Podešavanje unosa',
        Locks: 'Zaključavanje',
        'Backup & Restore': 'Bekap i obnova',
        'Audit Logs': 'Audit logovi',
        'Export Model': 'Izvoz modela',
        'Import Model': 'Uvoz modela',
        'Switch Tenants': 'Promena radnog prostora',
        Support: 'Podrška',
        'Help Center': 'Centar za pomoć',
        'Contact Support': 'Kontaktiraj podršku',
    },
    KPI_COLUMN_OPERATIONS: {
        minus: 'minus',
        divide: 'podeli',
        plus: 'plus',
        multiply: 'množi',
        percent: 'procenat',
        'percent thousands': 'procenat hiljada',
        'difference in %': 'razlika u %',
    },
    STATUS_MAP: {
        Resolved: 'Rešeno',
        Unresolved: 'Nerešeno',
        'In Review': 'U pregledu',
        QUEUED: 'U redu',
        RUNNING: 'U toku',
        FINISHED: 'Završeno',
        ERROR: 'Greška',
    },
    USER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create User': 'Kreiraj korisnika',
        'Delete User': 'Obriši korisnika',
        'Find All Users': 'Pronađi sve korisnike',
        'Get User': 'Dohvati korisnika',
        'Update User': 'Ažuriraj korisnika',
    },
    FEATURE_PERMISSIONS_TITLE_MAP: {
        TAGS_IN_MODEL: 'Objekti baze podataka u modelu',
        CLUSTER_FLOW_ADD: 'Dodavanje reda',
        YEAR_VERSION_LOCKS: 'Zaključavanja',
        IMPORT: 'Uvoz',
        SEE_ALL_IMPORT_JOBS: 'Pregled svih uvoznih poslova',
        USERS_GROUPS_MANAGEMENT: 'Upravljanje korisnicima i grupama',
        REMOTE_JOBS: 'Aplikacije',
        COMMENTS: 'Komentari',
        TAGS_SIDEBAR: 'Traka sa bazama podataka',
        CREDENTIALS: 'Prijavnice',
        INPUT_SETUP: 'Podešavanje unosa',
        AUDIT_LOGS: 'Pregled dnevnika nadzora',
        ASSIGNMENTS: 'Zadaci',
        BACKUP_AND_RESTORE: 'Bekap i obnova',
        DASHBOARD_TO_IMAGE: 'Izvoz kontrolne table u sliku',
        CHAT_AI: 'Čet AI',
        DELETE_DIMENSION: 'Obriši dimenziju',
        FORECAST: 'Prognoza',
        GOAL_SEEKING_TOP_DOWN: 'Traženje cilja odozgo nadole',
        MODEL_IMPEX: 'Uvoz/izvoz modela',
        OWD_MEASURES: 'Samo sa podacima za mere',
        FORMULA_QA: 'Formula QA',
        USE_HIERARCHY_IN_CALCULATION: 'Ažuriranje "koristi hijerarhiju" u varijablama',
        MODEL_HEALTH: 'Zdravlje modela',
        FARSEER_LABS: 'Farseer Labs',
        FARSEER_LOGO: 'Farseer logo',
    },
    CELL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Edit Cells': 'Uredi ćelije',
    },
    FOLDER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Folder': 'Kreiraj fasciklu',
        'Duplicate Folder': 'Dupliraj fasciklu',
        'Search Folders': 'Pretraga fascikli',
        'Get Items in Folder': 'Dohvati stavke u fascikli',
        'Find by Reverse References': 'Pronađi po obrnutim referencama',
        'Move Items': 'Premesti stavke',
        'Rename Items': 'Preimenuj stavke',
        'Delete Items in Folder': 'Obriši stavke iz fascikle',
        'Share Folder Hierarchy': 'Podeli hijerarhiju fascikle',
    },
    TAG_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Database Object': 'Kreiraj objekat baze podataka',
        'Delete Database Object': 'Obriši objekat baze podataka',
        'Get Database Object': 'Dohvati objekat baze podataka',
        'Update Database Object': 'Ažuriraj objekat baze podataka',
        'Search Database Objects': 'Pretraži objekte baze podataka',
    },
    SHEET_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Sheet': 'Kreiraj proračunskoj tabelu',
        'Get Sheet': 'Dohvati proračunskoj tabelu',
        'Update Sheet': 'Ažuriraj proračunskoj tabelu',
        'Duplicate Sheet': 'Dupliraj proračunskoj tabelu',
        'Search Rows in Sheet': 'Pretraži redove u proračunskoj tabeli',
        'Get Sheet Data': 'Preuzmi podatke o proračunskoj tabeli',
        'Set Sheet Data': 'Postavi podatke o proračunskoj tabeli',
    },
    SHEET_ROW_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Row': 'Kreiraj red',
        'Update Row': 'Ažuriraj red',
        'Delete Row': 'Obriši red',
        'Move Row': 'Premesti red',
        'Duplicate Row': 'Dupliciraj red',
        'Find All Row': 'Pronađi sve redove',
        'Get Row': 'Preuzmi red',
        'Materialize Row': 'Materijalizuj red',
    },
    SHARE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Share': 'Kreiraj zadatke',
        'Add Public Shares': 'Kreiraj javni zadatak',
        'Delete Share': 'Obriši zadatak',
        'Get Share': 'Preuzmi zadatak',
        'Update Share': 'Ažuriraj zadatak',
    },
    LABEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Get Label': 'Preuzmi oznaku',
        'Create Label': 'Kreiraj oznaku',
        'Update Label': 'Ažuriraj oznaku',
        'Delete Label': 'Obriši oznaku',
    },
    FARSEER_FILE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create File': 'Kreiraj datoteku',
        'Update File': 'Ažuriraj datoteku',
        'Delete File': 'Obriši datoteku',
        'Find All Files': 'Pronađi sve datoteke',
        'Get File': 'Preuzmi datoteku',
    },
    REMOTE_JOB_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Remote Job': 'Kreiraj aplikaciju',
        'Update Remote Job': 'Ažuriraj aplikaciju',
        'Find All Remote Jobs': 'Pronađi sve aplikacije',
        'Get Remote Job': 'Preuzmi aplikaciju',
        'Run Remote Job': 'Pokreni aplikaciju',
        'Run Remote Job As A Service': 'Pokreni aplikaciju kao uslugu',
    },
    OVERSEER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Restore Backup': 'Vrati rezervnu kopiju',
        'Create Backup': 'Kreiraj rezervnu kopiju',
        'Search Backups': 'Pretraži rezervne kopije',
        'Download Backup': 'Preuzmi rezervnu kopiju',
        'Upload Backup': 'Učitaj rezervnu kopiju',
    },
    MODEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Read Model': 'Čitanje modela',
        'Edit Model': 'Uređivanje modela',
    },
    DASHBOARD_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Dashboard': 'Kreiraj nadzornu tablu',
        'Duplicate Dashboard': 'Dupliciraj nadzornu tablu',
        'Find All Dashboards': 'Pronađi sve nadzorne table',
        'Get Dashboard': 'Preuzmi nadzornu tablu',
        'Update Dashboard': 'Ažuriraj nadzornu tablu',
    },
    FEATURE_PERMISSION_TITLES: {
        FeaturePermission: 'Dozvola za funkciju',
        FolderClassPermission: 'Dozvola za klasu fascikle',
        TagClassPermission: 'Dozvola za klasu oznaka',
        SheetClassPermission: 'Dozvola za klasu tablice',
        SheetRowClassPermission: 'Dozvola za klasu reda tablice',
    },
    SEARCH_TAGS: 'Pretraži oznake...',
    SEARCH_PERMISSIONS: 'Pretraži dozvole...',
    DEFAULT: 'Podrazumevano',
    FEATURE_PERMISSIONS: 'Dozvole za funkcije',
    CLASS_PERMISSIONS: 'Dozvole za klase',
    ADD_COMMENT: 'Dodaj komentar',
    SORT: 'Sortiraj',
    SORT_BY: 'Sortiraj po',
    ASCENDING: 'Rastuće',
    DESCENDING: 'Opadajuće',
    UNSORT: 'Ne sortiraj',
    AUTO: 'Auto',
    LEFT: 'Levo',
    ALL_MONTHS: 'Svi meseci',
    TWELVE_MONTHS: '12 meseci',
    YEAR_START: 'Početak godine',
    TIMELINE_START: 'Početak vremenske trake',
    COPY_HASH_TAG: 'Kopiraj #',
    SHOW_TOP: 'Prikaži najboljih',
    SHOW_REST: 'Prikaži ostatak',
    RIGHT: 'Desno',
    CENTER: 'Centar',
    TOP: 'Vrh',
    MIDDLE: 'Sredina',
    BOTTOM: 'Dno',
    YEAR_END: 'Kraj godine',
    TIMELINE_END: 'Kraj vremenske trake',
    CURRENT_YEAR: 'Trenutna godina',
    PREVIOUS_YEAR: 'Prethodna godina',
    CUSTOM: 'Prilagođeno',
    NEW_TABLE: 'Nova {name}',
    EDIT_TABLE: 'Uredi {name}',
    FOCUS_TABLE: 'Fokusiraj {name}',
    ROUND: 'Zaokruži',
    REGRESSION: 'Regresija',
    RANDOM: 'Nasumični broj',
    SET_VALUE: 'Postavi vrednost',
    APPLY_PERCENTAGE: 'Primeni procenat',
    APPLY_PERCENTAGE_CHAR: 'Primeni %',
    DELETE_COLUMNS_ON_ROW: 'Obriši kolone na redu',
    PROCESSING_FILE: 'Obrada datoteke',
    IMAGE_PREVIEW_FAILED: 'Prikaz slike nije uspeo',
    NEXT: 'Sledeće',
    PREVIOUS: 'Prethodno',
    PAGE_OF: 'Stranica {pageNumber} od {pages}',
    NO_TITLE: 'Bez naslova',
    DURATION: 'Trajanje',
    CELL_COUNT: 'Broj ćelija',
    NONCALCULATED: 'Neizračunato',
    CALCULATED: 'Izračunato',
    SEARCH_ASSIGNMENTS: 'Pretraži zadatke',
    BY_NAME: 'Po imenu',
    BY_LABEL: 'Po oznaci',
    BY_STATUS: 'Po statusu',
    BY_SHEET: 'Po proračunskoj tabeli',
    GROUP_BY: 'Grupiraj po',
    CHART_SPACING: 'Razmak grafikona',
    GRID_COLUMNS: 'Kolone mreže',
    GRID_SPACING: 'Razmak mreže',
    AXIS_SPACING: 'Razmak osa',
    RESET_FILTERS: 'Resetuj filtere',
    RESET_CONFIG: 'Resetuj konfiguraciju',
    RESET_CONFIG_TOOLTIP: 'Resetuj konfiguraciju na podrazumevano',
    BY_ASSIGNEE: 'Po izvršiocu',
    BY_APPROVER: 'Po odobravatelju',
    NEW_ASSIGNMENT: 'Novi zadatak',
    NEXT_ASSGN_DUE: 'Sledeći zadatak ističe',
    SHARE_SELECT_USER_PLACEHOLDER: 'Pretraži korisnike ili grupe...',
    CREATE_ASSIGNMENT_PLACEHOLDER: 'Kreiraj zadatak odabirom korisnika...',
    ASSIGNMENT_REFRESHED: 'Produžen rok završetka zadatka za 7 dana',
    CANT_EDIT_ASSIGNMENT: 'Ne može se uređivati već podneseni zadaci',
    NO_CHANGES: 'Bez promena',
    APPROVED: 'Odobreno',
    EXPIRED: 'Isteklo',
    READY_FOR_REVIEW: 'Spremno za pregled',
    IN_PROGRESS: 'U toku',
    SHARED: 'Deljeno',
    SHARED_WITH: 'Deljeno sa',
    ARCHIVED: 'Arhivirano',
    STILL_STUCK: 'I dalje ste zaglavljeni? Posjetite naš centar za pomoć.',
    NEED_HELP: 'Treba vam pomoć? Posjetite naš centar za pomoć.',
    WELCOME: 'Dobrodošli',
    WELCOME_MESSAGE: 'Odaberite nešto s bočne trake kako biste počeli, ili pretražite nešto specifično.',
    DEFAULT_MEMBER: 'Podrazumevani član',
    FAILED_TO_LOAD_MODEL: 'Model nije učitan',
    MODEL_LOADED: 'Model učitan',
    PREVIOUS_MESSAGE_IS_PROCESSING: 'Vaš prethodni zahtev se obrađuje. Molimo sačekajte...',
    RUN_ARGUMENTS: 'Pokreni argumente',
    EXPECTED_ARGUMENTS: 'Očekivani argumenti',
    RUN_ARGUMENTS_ERROR: 'Argumenti za pokretanje radnje su zastareli, molimo da ih ažurirate.',
    GENERAL: 'Opšti',
    SYSTEM: 'Sistem',
    BASIC_INFO: 'Osnovne informacije',
    LAST_RUN: 'Poslednje pokretanje',
    NEVER_RUN: 'Nikad pokrenuto',
    REMOTE_JOB_NAME: 'Naziv aplikacije',
    CHOOSE_FOLDER: 'Izaberi fasciklu',
    SOURCE_FOLDER: 'Izvorna fascikla',
    SELECT_SOURCE_FOLDER_WARNING: 'Molimo izaberite izvornu fasciklu',
    MAIN_FILE_HINT: 'Pritisnite na datoteku da biste označili skriptnu datoteku kao ulaznu tačku',
    NO_FILES: 'Nema datoteka',
    NO_MAIN_FILE: 'Nema glavne datoteke',
    FINDER_TOOLTIP: 'Prikaz tražilice',
    VARIABLE_TOOLTIP: 'Prikaz trake za varijable',
    sheet_ITEMS_TOOLTIP: 'Prikaz stavki tablice',
    LIST_ITEMS_TOOLTIP: 'Prikaži stavke liste',
    EXPAND_TOOLTIP: 'Proširi sve redove za jedan nivo',
    COLLAPSE_TOOLTIP: 'Skupi sve redove za jedan nivo',
    FORECAST_TOOLTIP: 'Prikaz napretka prognoze',
    EXPORT_TOOLTIP: 'Izvezi u .xlsx',
    APP_SHORTCUTS_TOOLTIP: 'Prečice aplikacija',
    TAGS_SIDEBAR_TOOLTIP: 'Otvori bočnu traku baza podataka',
    TILE_SIDEBAR_TOOLTIP: 'Otvori bočnu traku uređivanje ploče',
    COMMENTS_SIDEBAR_TOOLTIP: 'Otvori bočnu traku komentari',
    ADD_APP_SHORTCUT: 'Dodaj prečicu',
    APP_SHORTCUTS_PATH: 'Prečice aplikacija',
    CHANGE_SHORTCUT_ACTION: 'Promeni radnju',
    REMOVE_SHORTCUT: 'Ukloni prečicu',
    SHORTCUT_ADDED: 'Prečica uspešno dodana',
    SHORTCUT_REMOVED: 'Prečica uklonjena',
    SHORTCUT_ALREADY_EXISTS: 'Prečica već postoji',
    CHANGE_ACTION_TITLE: 'Promeni radnju',
    CHANGE_ACTION_LABEL: 'Izaberite jednu od sledećih radnji',
    ACTION_CHANGED: 'Radnja promenjena',
    ERROR_FETCHING_APP_DATA: 'Greška pri preuzimanju podataka aplikacije',
    ERROR_FETCHING_ACTION_ARGUMENTS: 'Greška pri preuzimanju argumenata radnje',
    INVALID_ACTION_ARGUMENTS: 'Nevažeći argumenti radnje',
    APP_STARTED_SUCCESSFULLY: 'Aplikacija uspešno pokrenuta',
    CREATE_BACKUP: 'Kreiraj sigurnosnu kopiju',
    BACKUP: 'Sigurnosna kopija',
    CREATE_BACKUP_WARNING: 'Jeste li sigurni da želite kreirati novu sigurnosnu kopiju?',
    RESTORE_BACKUP: 'Vrati sigurnosnu kopiju',
    RESTORE: 'Vrati',
    RESTORE_BACKUP_WARNING: 'Jeste li sigurni da želite vratiti se na sigurnosnu kopiju {backupPath}?',
    SELECT_MONTH: 'Izaberite mesec',
    REMOVE_FILTER: 'Ukloni filter',
    FILTER_BY: 'Filtriraj po...',
    STATIC_FILTER: 'Ovaj filter se ne može menjati',
    SELECT_ROW_TO: 'Odaberite red za pregled ili izmenu njegove promenljive',
    EDIT_ARGUMENT: 'Izmeni argument',
    ARGUMENT_NAME: 'Ime argumenta',
    DATA_TYPE_STRING: 'Tekst',
    DATA_TYPE_BOOLEAN: 'Boolean',
    DEFAULT_VALUE: 'Podrazumevana vrednost',
    ADD_OPTION: 'Dodaj opciju',
    OPTION_VALUE: 'Vrednost opcije',
    DROPDOWN_OPTIONS_MUST_BE_UNIQUE: 'Opcije moraju biti jedinstvene',
    DROPDOWN_OPTION_EMPTY: 'Opcija ne sme biti prazna',
    DROPDOWN_DEFAULT_AUTO_HINT: 'Podrazumevana vrednost nije izabrana — prilikom čuvanja biće korišćena prva opcija.',
    LOCKED_AT_RUN_TIME: 'Zaključaj vrednost prilikom pokretanja',
    LOCKED_AT_RUN_TIME_TOOLTIP: 'Kada je označeno, korisnici prilikom pokretanja aplikacije ne mogu promeniti ovu vrednost.',
    LOCKED_REQUIRES_DEFAULT: 'Zaključani argument mora imati podrazumevanu vrednost',
    SECRET: 'Tajna',
    SECRET_TOOLTIP: 'Vrednost je maskirana tokom unosa i u logovima',
    NAME_REQUIRED: 'Ime je obavezno',
    BACKUP_CREATED: 'Sigurnosna kopija kreirana',
    DOWNLOADING_BACKUP: 'Preuzimanje sigurnosne kopije',
    BACKUP_RESTORED: 'Sigurnosna kopija vraćena',
    UPLOAD_BACKUP: 'Učitaj sigurnosnu kopiju',
    UPLOADING: 'Učitavanje',
    SHOW_UPLOADED: 'Prikaži uploadane',
    INITIATED_BY: 'Pokrenuo',
    SAVE_AS_IMAGE: 'Sačuvaj kao sliku',
    CREATING_AND_SAVING_IMAGE: 'Kreiranje slike i čuvanje u datoteke...',
    IMAGE_SAVED: 'Slika sačuvana!',
    FAILED_TO_SAVE_IMAGE: 'Čuvanje slike nije uspelo',
    GOAL_VALUE: 'Ciljna vrednost',
    CURRENT_VALUE: 'Trenutna vrednost',
    PERCENTAGE_MET: '{percentage}% ispunjeno',
    UNFREEZE_CELLS: 'Odmrzni vrednosti',
    FREEZE_CELLS: 'Zamrzni vrednosti',
    UNSET_GOAL: 'Ukloni kao ciljnu vrednost',
    SET_GOAL: 'Postavi kao ciljnu vrednost',
    INSPECT_VALUE: 'Inspekcija vrednosti',
    EDITING_TILE: 'Uređivanje elementa',
    NO_TILE_SELECTED: 'Molimo odaberite element.',
    NO_TILE_OPTIONS: 'Nema dostupnih opcija.',
    TILE_NAME: 'Naziv elementa',
    ENTER_TILE_NAME: 'Unesite naziv elementa',
    USE_FILTERS_FROM: 'Koristi filtere iz',
    USE_SORT_FROM: 'Koristi sortiranje iz',
    USE_TIMELINE_FROM: 'Koristi vremensku liniju iz',
    SHOW_TILE_SORT: 'Prikaži sortiranje ovog elementa',
    SHOW_TILE_FILTERS: 'Prikaži filtere pločice',
    SHOW_TILE_TIMELINE: 'Prikaži vremensku liniju pločice',
    DASHBOARD: 'Kontrolna tabla',
    TILE: 'Element',
    CHART_COLUMN_OPTIONS: 'Opcije kolone',
    CHART_ROW_OPTIONS: 'Opcije reda',
    GENERAL_STYLING: 'Opšte stilizovanje',
    PER_ROW_STYLING: 'Stilizovanje po redu',
    PER_COLUMN_STYLING: 'Stilizovanje po koloni',
    TEXT_STYLE: 'Stil teksta',
    ROW_STYLE: 'Stil reda',
    COLOR: 'Boja',
    PALETTE: 'Paleta',
    BACKGROUND: 'Pozadina',
    BORDER: 'Obrub',
    SHADOW: 'Senka',
    TOP_BORDER: 'Gornji obrub',
    BOTTOM_BORDER: 'Donji obrub',
    INNER_BORDER: 'Unutrašnji obrub',
    RESET_GENERAL_STYLES: 'Resetuj opšte stilove',
    RESET_ALL_PER_ROW_STYLES: 'Resetuj sve stilove po redu',
    RESET_ALL_PER_COLUMN_STYLES: 'Resetuj sve stilove po koloni',
    RESET_STYLES: 'Resetuj stilove',
    ADD_TABLE: 'Nova dimenzionalna tabela',
    ADD_VARIABLE: 'Nova varijabla',
    ADD_SHEET: 'Nova tabela',
    ADD_DASHBOARD: 'Nova nadzorna ploča',
    ADD_APP: 'Dodaj aplikaciju',
    ADD_FILE: 'Dodaj fajl',
    ADD_FOLDER: 'Dodaj fasciklu',
    ENABLED: 'Omogućeno',
    NEW_TEMPLATE: 'Nova šablona',
    EDIT_TEMPLATE: 'Uredi šablonu',
    SAVE_SELECTION_AS_TEMPLATE: 'Sačuvaj selekciju kao šablonu',
    TEMPLATE_CREATED: 'Šablona kreirana',
    TEMPLATE_UPDATED: 'Šablona ažurirana',
    TEMPLATE_DELETED: 'Šablona obrisana',
    TEMPLATE_NAME: 'Naziv šablone',
    TEMPLATE_DESCRIPTION: 'Opis šablone',
    QUANTITY: 'Količina',
    ENTER_TEXT: 'Unesite tekst',
    ENTER_NUMBER: 'Unesite broj',
    PICK_A_DATE: 'Izaberite datum',
    ERROR_CREATING_DIMENSION: 'Greška prilikom kreiranja nove dimenzije',
    ALLOW_MULTI_CREATE: 'Dozvoli kreiranje više stavki odjednom',
    ALLOW_NAME_DESC_CONN_ON_CREATE: 'Postavi naziv, opis i veze pri kreiranju',
    ALLOW_PROPERTIES_ON_CREATE: 'Postavi svojstva pri kreiranju',
    NAMING_CONFIG_ENABLED: '(Konfiguracija imenovanja omogućena)',
    DIMENSION_TABLE: 'Dimenzijska tablica',
    DIMENSION_TABLES: 'Dimenzionalne tabele',
    DIMENSION_MEMBER: 'Član dimenzije',
    DIMENSION_MEMBERS: 'Članovi dimenzije',
    ASK_WHEN_CREATING: 'Pitaj prilikom kreiranja',
    PREDEFINED_CONNECTIONS: 'Unapred definisane konekcije',
    REQUIRED: 'Potrebno',
    CHOOSE_A_TABLE_FIRST: 'Prvo izaberite tabelu za postavljanje veza',
    BIND_TO_TIMELINE: 'Poveži sa vremenskom trakom',
    NEW_VARIABLE_COLUMN: 'Nova varijabilna kolona',
    NEW_DIMENSION_COLUMN: 'Nova dimenzionalna kolona',
    NEW_LOOKUP_COLUMN: 'Nova kolona pretrage',
    NEW_COMPARISON_COLUMN: 'Nova poređenje kolona',
    EDITING_CUSTOM_COLUMN: 'Uređivanje prilagođene kolone',
    LOOKUP_PROPERTIES: 'Svojstva pretrage',
    CALCULATION_COLUMN: 'Kolona za računanje',
    ADD_COLUMNS: 'Dodaj kolone',
    COLUMN_NAME: 'Naziv kolone',
    DELETE_CUSTOM_COLUMN_CONFIRMATION: 'Da li ste sigurni da želite obrisati ovu kolonu?',
    AUTOGENERATED_CUSTOM_COLUMN_NAME: 'Ostavite prazno za automatski generisano ime',
    NOTE_INSPECT_VALUE: 'Napomena: "Inspekcija vrednosti" funkcija prikazuje do 500 redova. Za pregled svih podataka, izvezite kompletni skup podataka.',
    COPY_FROM: 'Kopiraj iz',
    PREVIEW: 'Pregled',
    DECIMALS: 'Decimalna mesta',
    SIGNS: 'Negativni brojevi',
    NEGATIVE_SIGNS: {
        SIGNED: 'Minus',
        UNSIGNED: 'Zagrada',
        EXPLICIT: 'Plus/Minus',
    },
    POLARITY_SIGNS: {
        POSITIVE: 'Pozitivno',
        NEGATIVE: 'Negativno',
    },
    BASE_UNIT: 'Osnovna jedinica',
    BASE_UNITS: {
        ONES: 'Jedan',
        THOUSANDS: 'Hiljade',
        MILLIONS: 'Milioni',
        BILLIONS: 'Milijarde',
        AUTO: 'Automatski',
    },
    CURRENCY_UNITS: {
        EUR: '€',
        USD: '$',
        HRK: 'HRK',
    },
    MONTHS: {
        January: 'Januar',
        February: 'Februar',
        March: 'Mart',
        April: 'April',
        May: 'Maj',
        June: 'Jun',
        July: 'Jul',
        August: 'Avgust',
        September: 'Septembar',
        October: 'Oktobar',
        November: 'Novembar',
        December: 'Decembar',
    },
    MONTHS_SHORT: {
        Jan: 'Jan',
        Feb: 'Feb',
        Mar: 'Mar',
        Apr: 'Apr',
        May: 'Maj',
        Jun: 'Jun',
        Jul: 'Jul',
        Aug: 'Aug',
        Sep: 'Sep',
        Oct: 'Okt',
        Nov: 'Nov',
        Dec: 'Dec',
    },
    DAYS: {
        Sunday: 'Nedelja',
        Monday: 'Ponedeljak',
        Tuesday: 'Utorak',
        Wednesday: 'Sreda',
        Thursday: 'Četvrtak',
        Friday: 'Petak',
        Saturday: 'Subota',
    },
    DAYS_SHORT: {
        Sun: 'Ned',
        Mon: 'Pon',
        Tue: 'Uto',
        Wed: 'Sri',
        Thu: 'Čet',
        Fri: 'Pet',
        Sat: 'Sub',
    },
    CURRENCY: 'Valuta',
    SIGNING_IN: 'Prijavljivanje...',
    NEW_RELATION_COLUMN: 'Nova kolona relacije',
    SELECT_TABLE_LOOKUP: 'Izaberite tabelu za pretragu',
    SELECT_TABLE_RELATION: 'Poveži članove reda sa',
    SELECT_TABLE_PROPERTY: 'Izaberite svojstvo iz tabele',
    DISPLAY_TABLE_PROPERTY: 'Prikaži svojstvo iz tabele',
    FILTER_MEMBERS: 'Filtriraj izbor članova filterima radnog lista',
    TABLE_RELATION: 'Relacija tabele',
    FILTER_DISPLAY: 'Filtriraj prikaz',
    RELATE_TABLE: 'Poveži sa tabelom',
    USE_BLANKS: 'Koristi prazna polja',
    NO_DATA_TO_DISPLAY: 'Nema podataka za prikaz',
    USE_REFERENCE_FILTERS: 'Koristi njegove filtere',
    USE_REFERENCE_TIMELINE: 'Koristi njegovu vremensku liniju',
    USE_REFERENCE_ROWS: 'Koristi njegove redove',
    USE_REFERENCE_COLUMNS: 'Koristi njegove kolone',
    REFERENCE_ANOTHER_SHEET: 'Referenciraj drugi radni list',
    NO_SHEET_SELECTED: 'Nijedan radni list nije odabran',
    SELECT_SHEET: 'Izaberite radni list',
    SHEET_REFERENCED: 'Radni list uspešno referenciran',
    CANNOT_ADD_ROWS: 'Nije moguće dodati redove dok je referencirano',
    CANNOT_EDIT_ROWS: 'Nije moguće uređivati redove dok je referencirano',
    CANNOT_EDIT_COLUMNS: 'Nije moguće uređivati kolone dok je referencirano',
    CANNOT_ADD_COLUMNS: 'Nije moguće dodati kolone dok je referencirano',
    CANNOT_ADD_FILTERS: 'Nije moguće dodati filtere dok je referencirano',
    REVERSE_DIMENSION: 'obrnuto povezana dimenzija',
    REMOVE_FROM_RULE: 'Ukloni iz pravila',
    NEW_RULE: 'Novo pravilo',
    DUPLICATE_RULE: 'Dupliraj pravilo',
    REMOVE_RULE: 'Ukloni pravilo',
    VARIABLE_LOCK_INFO_TITLE: 'Ova varijabla će koristiti samo ovo pravilo.',
    VARIABLE_LOCK_INFO_BODY: 'Ostala pravila će biti zanemarena. Da biste zaključali celu varijablu, ostavite sekciju dimenzija praznom.',
    DELETED: 'Obrisano',
    DONE: 'Gotovo',
    CHOOSE_ITEMS_TO_EXPORT: 'Izaberite stavke za izvoz',
    UPLOAD_MODEL_FILE: 'Učitajte datoteku modela',
    NO_FILE_SELECTED: 'Nijedna datoteka nije izabrana',
    BACK: 'Nazad',
    ALLOW_IMPORT_TO: 'Dozvoli uvoz u',
    FINISHED: 'Završeno',
    IMPORT_PREVIEW: 'Ovo je pregled promena koje bi uvoz primenio sa trenutnim podešavanjima.\n\nPromene:\n',
    IMPORT_FINISHED: 'Uvoz završen.\n\nPromene:\n',
    LOADING_MODEL: 'Uvoz modela iz datoteke...',
    CUSTOM_COLUMN: 'Prilagođena kolona',
    EXPAND_ROW_COLUMN_TOOLBAR: 'Proširi traku redova i kolona',
    SEARCH_FOR_EXPRESSIONS: 'Pretraži funkcije, varijable, dimenzije…',
    NEW: 'Novo',
    SELECT_A_CELL: 'Izaberite ćeliju koja sadrži vrednost za prikaz formule',
    SELECT_A_CELL_TO_EDIT_ROWS: 'Izaberite ćeliju za uređivanje redova',
    OR_COLUMNS: 'ili kolone',
    MANAGE_PERMISSIONS_FOR: 'Upravljaj dozvolama za "{name}"',
    VIEW_ONLY: 'Samo pregled',
    DATA_EDIT: 'Uređivanje podataka',
    EDIT_OWNED: 'Uredi sopstveno',
    FULL_EDIT: 'Potpuno uređivanje',
    UNKNOWN_USER: 'Nepoznat korisnik',
    UNKNOWN_GROUP: 'Nepoznata grupa',
    BUTTON_STYLE: 'Stil dugmeta',
    BUTTON_STYLES: {
        primary: 'Primarno',
        secondary: 'Sekundarno',
        tertiary: 'Tercijarno',
        quaternary: 'Kvaternarno',
    },
    APP_ICON: 'Ikona aplikacije',
    LAST_MODIFIED_BY: 'Poslednji put izmenio/la {name}',
    LAST_MODIFIED_BY_COLUMN: 'Poslednji izmenio',
    LAST_MODIFIED_AT_COLUMN: 'Poslednja izmena',
    SHOW: 'Prikaži',
    FORMULA_QA: 'Formula QA',
    TIME_LIMIT: 'Vremensko ograničenje',
    RESTRICTIONS: 'Ograničenja',
    SEARCH_FOR_USERS_GROUPS: 'Pretraži korisnike ili grupe…',
    SEARCH_OR_ADD_USERS_GROUPS: 'Pretraži ili deli sa korisnicima, grupama ili javno…',
    STATUS_TRACKING: 'Praćenje statusa',
    STATUS_TRACKING_MESSAGE: 'Praćenje omogućava korisniku ili grupi da podnese svoje promene i zatraži vaše odobrenje.',
    TRACK_STATUS: 'Prati status',
    STOP_TRACKING: 'Zaustavi praćenje',
    RESTART_TRACKING: 'Ponovo pokreni praćenje',
    ALL: 'Sve',
    TRACKED: 'Praćeno',
    UNTRACKED: 'Nepraćeno',
    ALL_TRACKED: 'Sva praćena',
    MY_TRACKED: 'Moja praćena',
    MY_APPROVALS: 'Moja odobrenja',
    ALL_SHARES: 'Sva deljenja',
    SUPER_USERS: 'Super korisnici',
    LOADING_SUPER_USERS: 'Učitavanje super korisnika...',
    CANNOT_EDIT_WHEN_TIME_LIMIT: 'Uređivanje nije moguće dok je vremensko ograničenje aktivno',
    CANNOT_EDIT_WHEN_TRACKED: 'Uređivanje nije moguće dok je status praćen',
    EXPORT_SHARES_TO_XLS: 'Izvezi deljenja u .xls',
    SHARE_COPIED: 'Deljenje kopirano!',
    SHARES_COPIED: 'Deljenja kopirana!',
    COPY_SHARE_IN_FOLDER: 'Kopiraj na sve u ovoj fascikli',
    COPY_AND_OVERRIDE_SHARES: 'Kopiraj i zameni deljenja',
    COPY_AND_OVERRIDE_SHARES_CONFIRMATION: 'Sva postojeća deljenja na stavkama i fasciklama unutar ove biće zamenjena deljenjima trenutne fascikle.',
    COPY_ALL_SHARES_IN_FOLDER: 'Kopiraj i zameni sva deljenja u ovoj fascikli',
    GRID_SINGLE_CHART_EXPLANATION: 'Jedan grafikon sa redovima najvišeg nivoa',
    GRID_MULTIPLE_CHART_EXPLANATION: 'Mreža malih grafikona, po jedan za svaki red najvišeg nivoa',
    DUPLICATE_KEYS_FOUND: 'Pronađeni duplirani ključevi',
    DUPLICATE_KEYS_PROMPT: 'Da li želite da filtrirate i kreirate samo jedinstvene stavke?',
    NAMES_SHOULD_BE_UNIQUE: 'Imena moraju biti jedinstvena',
    LIMIT_TO_FILTERED_OPTIONS: 'Ograniči na filtrirane opcije',

    // Toast messages
    SWITCHING_TENANT: 'Prebacivanje radnog prostora',
    TENANT_SWITCHED_SUCCESS: 'Radni prostor uspešno prebačen',
    TENANT_SWITCH_FAILED: 'Nije uspelo učitati podatke novog radnog prostora. Molimo osvežite stranicu',
    FAILED_LOAD_MESSAGES: 'Nije uspelo učitati poruke',
    NEW_CHAT_CREATED: 'Novi razgovor stvoren!',
    FAILED_LOAD_CHATS: 'Nije uspelo učitati razgovore.',
    FAILED_CREATE_CHAT: 'Nije uspelo stvoriti novi razgovor.',
    FAILED_SEND_MESSAGE: 'Nije uspelo stvoriti novi razgovor ili poslati poruku.',
    FAILED_RENAME_CHAT: 'Nije uspelo preimenovati razgovor.',
    FAILED_DELETE_CHAT: 'Nije uspelo obrisati razgovor.',
    XLSX_FILE_ONLY: 'Samo .xlsx datoteke',
    JSON_FILE_ONLY: 'Samo .json datoteke',
    EXPORT_DONE: 'Gotovo!',
    LOCKS_SAVED: 'Zaključavanja sačuvana',
    COPIED_TO_CLIPBOARD: 'Kopirano u međuspremnik',
    INVALID_INTERVAL: 'Nevažeći interval',
    SELECT_REQUIRED_DIMENSIONS: 'Odaberite potrebne dimenzije.',
    ENTITY_TYPE_NOT_SPECIFIED: 'Tip entiteta nije naveden',
    FAILED_EXPORT_VARIABLE: 'Nije uspelo izvesti varijablu: {message}',

    // Button labels
    OK: 'U redu',
    DELETE_ENTITY: 'Obriši entitet',
    SAVE_ENTITY: 'Sačuvaj entitet',
    GENERATED_ENTITIES: 'Generisani entiteti',
    NEW_ENTITY: 'Novi entitet',
    ENTITIES: 'Entiteti',
    SHOW_LOGS: 'Prikaži zapisnike',
    CALCULATE: 'Izračunaj',
    FORMULA_QA_TITLE: 'Formula QA',
    RENAME_CHAT: 'Preimenuj razgovor',
    SEND: 'Pošalji',
    EXPORT_CURRENT_SHEET: 'Izvezi trenutnu tabelu',
    TERMINATE: 'Prekini',
    CONFIRM_UPDATE: 'Potvrdi ažuriranje',

    // Form labels and placeholders
    FROM_DATE: 'Od datuma',
    TO_DATE: 'Do datuma',
    AUDIT_TYPE: 'Tip revizije',
    SELECT_AUDIT_TYPE: 'Odaberite tip revizije',
    USER: 'Korisnik',
    PAGE_SIZE: 'Veličina stranice',
    SELECT_PAGE_SIZE: 'Odaberite veličinu stranice',
    SELECT_USER: 'Odaberite korisnika',
    EXPORT_EXPANDED_ROWS: 'Izvezi trenutno proširene redove',
    EXPORT_ALL_ROWS: 'Izvezi sve redove',
    EXPORT_FILENAME_LABEL: 'Naziv',
    INCLUDE_CELLS: 'Uključi ćelije',
    INCLUDE_MEMBERS: 'Uključi članove',
    MESSAGE_FARSEER_AI: 'Poruka za FarseerAI...',
    ENTER_NEW_CHAT_NAME: 'Unesite novo ime razgovora',
    FLAG: 'Oznaka',

    // Chat suggestions
    CHAT_SUGGESTION_SUMMARY: 'Daj mi kratak sažetak modela',
    CHAT_SUGGESTION_DIMENSIONS: 'Postoje li varijable koje imaju više dimenzija od varijabli korišćenih u njihovoj formuli?',
    CHAT_SUGGESTION_DELAY: 'Koriste li neke varijable funkciju delay()?',
    CHAT_SUGGESTION_ONDEMAND: 'Navedi sve varijable na zahtev',
    CHAT_SUGGESTION_MEASURES: 'Navedi sve mere',
    CHAT_SUGGESTION_FIXED: 'Navedi sve varijable koje koriste fiksnu dimenziju',
    CHAT_SUGGESTION_DATE: 'Navedi sve dimenzije koje imaju svojstvo datuma',

    // Loading defaults
    DEFAULT_LOADING: 'Učitavanje...',
    DEFAULT_SUCCESS: 'Uspeh!',

    // Audit logs
    TOTAL_RESULTS: 'Ukupno rezultata: {count}',
    PAGE_OF_TOTAL: 'Stranica {current} od {total}',
    DB_ID: 'ID baze',
    DATE_AND_TIME: 'Datum i vreme',
    LOG_TYPE: 'Tip zapisnika',
    DATA: 'Podaci',

    // Entity debugger
    NO_TYPES: 'Nema tipova',

    // Formula QA Modal
    RESULT: 'Rezultat: {value}',
    ENTER_FORMULA_TO_CALCULATE: 'Unesite formulu za izračun rezultata.',

    // Model export
    EXPORTING_MODEL_ITEMS: 'Izvoz odabranih stavki modela...',

    // Search
    RECENTLY_SEARCHED: 'Nedavno pretraženo',
};

export default {
    ...(baseLanguageValues as Translation),
    ...translationValues,
};
